export const enTranslations = {
  companyInfo: {
    title: "Company Information",
    description:
      "Create company information to save time in management. It only takes two minutes to set up.",
    basicInfo: "Basic Information",
    companyName: "Company Name",
    businessIdNumber: "Business ID Number",
    representative: "Company Representative",
    business: "Business Type",
    capital: "Capital Amount",
    contactInfo: "Contact Information",
    email: "Email",
    localPhone: "Local Phone",
    fax: "Fax",
    contact: "Contact Person",
    phone: "Phone",
    department: "Department",
    address: "Contact Address",
    city: "City",
    district: "District",
    postalCode: "Postal Code",
    fullAddress: "Address",
    advancedSettings: "Advanced Settings",
    logo: "Logo",
    website: "Website",
    companyAbbreviation: "Company Abbreviation",
    invoiceTitle: "Invoice Title",
    invitationCode: "Invitation Code",
    enterInvitationCode: "Enter Invitation Code",
    errorFetchingData: "Error fetching company data:",
    errorUpdatingData: "Error updating company data:",
    forbidden: "Forbidden",
    saveSuccess: "Company information saved successfully",
    logoUploadSuccess: "Logo uploaded successfully",
    logoUploadError: "Error uploading logo",
    uploading: "Uploading...",
    uploadLogo: "Upload Logo",
    noLogo: "No logo uploaded",
    save: "Save Changes",
  },
  addCompany: {
    title: "Add Company",
    description:
      "Create company information to save time in management. It only takes two minutes to set up.",
    basicInfo: "Basic Information",
    companyInfo: "Company Information",
    businessIdNumber: "Business ID Number",
    representative: "Company Representative",
    business: "Business Type",
    capital: "Capital Amount",
    contactInfo: "Contact Information",
    localPhone: "Local Phone",
    fax: "Fax",
    contact: "Contact Person",
    phone: "Phone",
    department: "Department",
    contactAddress: "Contact Address",
    city: "City",
    district: "District",
    postalCode: "Postal Code",
    address: "Address",
    advancedSettings: "Advanced Settings",
    logo: "Logo",
    website: "Website",
    companyAbbreviation: "Company Abbreviation",
    invoiceTitle: "Invoice Title",
    invitationCode: "Invitation Code",
    enterInvitationCode: "Enter Invitation Code",
    cancel: "Cancel",
  },
  login: {
    title: "Login",
    googleLogin: "Google Login",
    continueWithGoogle: "Continue with Google",
    processingLogin: "Processing login...",
    or: "or",
    account: "Account",
    password: "Password",
    passwordPlaceholder: "Please enter 6 digits combination",
    rememberAccount: "Remember Account",
    noAccount: "No account? Register now",
    accountRequired: "Account cannot be empty",
    passwordRequired: "Password cannot be empty",
    loginError: "Incorrect account or password",
  },
  signup: {
    passwordTooShort: "Password too short",
    passwordTooShortDescription: "Password must be at least 8 characters",
    title: "Register",
    googleLogin: "Quick Register",
    or: "or",
    email: "Email",
    setPassword: "Set Password",
    confirmPassword: "Confirm Password",
    passwordPlaceholder: "Please enter 6 digits combination",
    register: "Register",
    haveAccount: "Already have an account? Login now",
    name: "Name*",
    phoneNumber: "Phone Number",
    country: "Country and Region*",
    bio: "Personal Introduction",
    howDidYouHear: "How did you hear about Guangda ERP:",
    companyRequirement: "Company Requirement",
    friendRecommendation: "Friend Recommendation",
    internet: "Internet",
    exhibition: "Exhibition/Fair",
    emailNotification: "Email",
    agent: "Agent/Dealer",
    confirm: "Confirm",
    allFieldsRequired: "All fields are required",
    allFieldsRequiredDescription:
      "Please ensure all fields are filled out completely",
    passwordMismatch: "Password mismatch",
    passwordMismatchDescription:
      "Password and confirm password do not match, please re-enter",
    registerSuccess: "Registration successful",
    registerSuccessDescription: "Account has been successfully created",
    registerFailed: "Registration failed",
    registerFailedDescription:
      "An error occurred during registration, please try again later",
    serverError: "Server error, please try again later",
  },
  hrMain: {
    basicInfo: "Basic Information",
    companyCalendar: "Calendar",
    companyInfo: "Company Information",
    employeeManagement: "Employee Management",
    departmentManagement: "Department Management",
    warRoom: "War Room",
    subscriptionPlan: "Subscription Plan",
    projectManagement: "Project Management",
    quotationStage: "Quotation Stage",
    archivedProjects: "Archived",
    editQuotationStage: "Edit Quotation Stage",
    productionPreparation: "Production Preparation",
    productionStage: "Production Stage",
    finance: "Finance",
    accountsReceivable: "Accounts Receivable (Customer)",
    accountsPayable: "Accounts Payable (Supplier/Credit Card/Personal)",
    bank: "Bank",
    bankManagement: "Bank Management",
    product: "Product",
    itemEditor: "Item Editor",
    warehouse: "Warehouse",
    warehouseLocation: "Warehouse and Location Management",
    stockHistory: "Stock Movement History",
    warehouseSystem: "Warehouse Management System",
    productManagement: "Product Management",
    inventoryManagement: "Inventory Management",
    inventoryCreated: "Created",
    inventoryDone: "Inventory Summary",
    materialRequest: "Material Request Management",
    materialRequestCreated: "Created",
    materialRequestDone: "Material Request Summary",
    purchase: "Purchase",
    purchaseOrder: "Purchase Order",
    draft: "Draft",
    underReview: "Under Review",
    approved: "Approved",
    completed: "Completed",
    partner: "Partner",
    partnerList: "Partner List",
    disabled: "Disabled",
    materialBOM: "Material BOM",
    addMaterialBOM: "Add Material BOM",
    boltBOM: "Bolt BOM",
    addBoltBOM: "Add Bolt BOM",
    designBOM: "Design BOM",
    addDesignBOM: "Add Design BOM",
    // Additional keys for HRMainPage
    underReviewStatus: "Under Review",
    purchaseOrderDraft: "Purchase Order Draft",
    purchaseOrderUnderReview: "Purchase Order Under Review",
    purchaseOrderApproved: "Purchase Order Approved",
    purchaseOrderCompleted: "Purchase Order Completed",
    rfq: "RFQ",
    rfqDraft: "RFQ Draft",
    rfqUnderReview: "RFQ Under Review",
    rfqCompleted: "RFQ Completed",
    inventoryManagementCreated: "Inventory Management Created",
    inventoryManagementCompleted: "Inventory Management Completed",
    materialRequestCreatedPage: "Material Request Created",
    materialRequestCompletedPage: "Material Request Completed",
    edit: "Edit",
    list: "List",
    // Add buttons and actions
    add: "Add",
    addPartner: "Add Partner",
    addEmployee: "Add Employee",
    addCompany: "Add Company",
    addDepartment: "Add Department",
    addProduct: "Add Product",
    addWarehouse: "Add Warehouse",
    addInventory: "Add Inventory",
    addStockRequest: "Add Stock Request",
    addPurchaseOrder: "Add Purchase Order",
    // Manual actions
    manualAdd: "Manual Add",
    // Success messages
    createSuccess: "Created successfully!",
    editSuccess: "Edited successfully!",
    deleteSuccess: "Deleted successfully!",
    editFailed: "Edit failed",
    createPartnerSuccess: "Partner created successfully!",
    createCompanySuccess: "Company created successfully!",
    createDepartmentSuccess: "Department created successfully!",
    createEmployeeSuccess: "Employee created successfully!",
    createProductSuccess: "Product created successfully!",
    createWarehouseSuccess: "Warehouse created successfully!",
    createInventorySuccess: "Inventory created successfully!",
    createStockRequestSuccess: "Stock request created successfully!",
    createPurchaseOrderSuccess: "Purchase order created successfully!",
    editWarehouseSuccess: "Warehouse edited successfully!",
    // Confirmation and form buttons
    confirm: "Confirm",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    deactivate: "Deactivate",
    reactivate: "Reactivate",
    apply: "Apply",
    cancelApplication: "Cancel Application",
    confirmDeactivation: "Confirm Deactivation",
    confirmEdit: "Confirm Edit",
    confirmExcelEdit: "Confirm Excel Edit",
    openImmediately: "Open Immediately",
    // Empty state messages
    noPartnerDataYet: "You haven't added partner data yet! You can try:",
    noProductDataYet: "You haven't added product data yet! You can try:",
    noWarehouseDataYet: "You haven't added warehouse data yet! You can try:",
    noEmployeeDataYet: "You haven't added employee data yet! You can try:",
    // Form confirmations
    confirmCancelAddEmployee:
      "Are you sure you want to cancel adding employee?",
    // Work item actions
    editWorkItem: "Edit Work Item",
    deleteWorkItem: "Delete Work Item",
    // Placeholders
    enterItemName: "Please enter item name",
    selectPersonnel: "Please select personnel",
    selectScanCount: "Please select scan pass count",
    enterCharacters: "Enter characters",
    enterSupervisorName: "Enter supervisor name",
    enterMemberName: "Enter member name",
  },
  departmentManagement: {
    noDepartments: "You haven't added any department data yet! You can try:",
    quickCreate: "Quick Create",
    manualAdd: "Manual Add",
    addDepartment: "Add Department",
    code: "Code",
    name: "Name",
    description: "Department Description",
    searchPlaceholder: "Search departments...",
    errorFetchingData: "Error fetching department data:",
  },
  departmentPage: {
    departmentName: "Department Name",
    departmentCode: "Department Code",
    departmentDescription: "Department Description",
    departmentLeaders: "Department Leaders",
    departmentMembers: "Department Members",
    deleteDepartment: "Delete Department",
    errorFetchingData: "Error fetching department data:",
    errorDeletingData: "Error deleting department data:",
  },
  productionPlanFlow: {
    nodeAlreadyHasParent:
      "This node already has a parent node and cannot have another parent",
    invalidConnection:
      "Invalid connection: {sourceType} cannot connect to {targetType}",
    sourceOrTargetNotFound: "Source or target node not found",
    zone: "Zone",
    batch: "Batch",
    package: "Steel Assembly Package",
    building: "Building",
    layerColors: "Layer Colors",
    deleteConfirmTitle: "Confirm Delete",
    deleteConfirmMessage: "Are you sure you want to delete the selected items?",
    cancel: "Cancel",
    priorityMode: "Priority",
    prioritySave: "Save",
    priorityDuplicate: "Priority numbers must be unique",
    startTime: "Start Time",
    endTime: "End Time",
    timeInvalid: "End time cannot be earlier than start time",
  },
  signPrint: {
    exitTitle: "Leave print preview?",
    exitContent: "Signatures placed on the document will not be kept.",
    exitOk: "Leave",
    exitCancel: "Keep editing",
    sign: "Sign",
    print: "Print",
    close: "Close",
    signature: "Signature",
    removeSignature: "Remove signature",
    resizeSignature: "Resize signature",
    dragHint: "Drag the signature onto the document (tap to drop it in the middle of the view). Drag to move, drag the bottom-right corner to resize, × to remove, then Print.",
  },
  docAnnotate: {
    missingFile: "No document to open",
    viewDocument: "View Document",
    tool: {
      pan: "Scroll",
      select: "Select / Move",
      pen: "Draw",
      text: "Text",
      rect: "Rectangle",
      rectFilled: "Filled Rectangle",
      ellipse: "Circle",
      ellipseFilled: "Filled Circle",
      arrow: "Arrow",
      signature: "Signature",
    },
    color: "Color {{color}}",
    width: "Width {{width}}",
    undo: "Undo",
    redo: "Redo",
    delete: "Delete selected annotation",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    download: "Download Annotated",
    close: "Close",
    downloaded: "Annotated copy downloaded. The original file is unchanged",
    downloadFailed: "Download failed. Please try again later",
    loadFailed: "This document can't be opened here",
    openInNewTab: "Open in new tab",
    textPlaceholder: "Type text, press Enter to finish",
    annotatedSuffix: "annotated",
    closeConfirmTitle: "Close document?",
    closeConfirm: "Annotations are not saved to the system and will be lost. Download the annotated copy first if you need it.",
    closeAnyway: "Close anyway",
    keepEditing: "Keep editing",
    unlockTitle: "Use Signature",
    unlockHint: "Enter your signature password to load your signature.",
    signatureReady: "Signature ready. Drag it onto the document",
    signatureMissingTitle: "No signature uploaded",
    signatureMissing: "Go to HR > Employees, edit your own profile, and upload a signature with a signature password first.",
    signatureDragHint: "Drag the signature onto the document, or pick the Signature tool and tap the page. Drag the corner to resize after placing.",
    ok: "OK",
  },
  quotation: {
    downloadError: "Download failed",
    downloadErrorDesc: "Could not download directly; the file was opened instead. Please save it manually.",
    basicInfo: "Basic Information",
    name: "Name",
    date: "Date",
    partner: "Partner",
    customer: "Partner (Customer)",
    remarks: "Remarks",
    address: "Address",
    projectStatus: "Project Status",
    company: "Company",
    city: "City",
    district: "District",
    postalCode: "Postal Code",
    fullAddress: "Full Address",
    fileUpload: "File Upload",
    contractUpload: "Contract Upload",
    addFile: "Add File",
    businessManagementSystem: "Business Management System",
    managePartnersAndOrders: "Manage Partners and Orders",
    noName: "Unnamed",
    noPartner: "No Partner Set",
    openGoogleMaps: "Open in Google Maps",
    collapse: "Collapse",
    expand: "Expand",
    addressInfo: "Address Information",
    namePlaceholder: "Please enter name",
    datePlaceholder: "Please select date",
    partnerPlaceholder: "Please select partner",
    cityPlaceholder: "Please enter city",
    districtPlaceholder: "Please enter district",
    postalCodePlaceholder: "Please enter postal code",
    fullAddressPlaceholder: "Please enter full address",
    remarksPlaceholder: "Please enter remarks",
    viewFiles: "View Uploaded Files",
    clickToUpload: "Click or drag files here",
    clickToUploadContract: "Upload Contract Document",
    supportedFormats: "Support various document formats",
    viewFile: "View File",
    downloadFile: "Download File",
    deleteFile: "Delete",
    folder: "Folder",
    backToFolders: "Back to Folders",
    files: "files",
    noFiles: "No files in this folder",
    selectFolder: "Select Folder",
    selectFolderDescription: "Please select which folder to upload to",
    viewContract: "View Contract Document",
    supportedContractFormats: "Support PDF, Word and other formats",
    uploadSuccess: "Upload Success",
    fileUploadedSuccessfully: "File uploaded successfully",
    contractUploadedSuccessfully: "Contract uploaded successfully",
    fileUploadFailed: "File upload failed",
    contractUploadFailed: "Contract upload failed",
    fileDeletedSuccessfully: "File deleted successfully",
    contractDeletedSuccessfully: "Contract deleted successfully",
    deleteError: "Delete Failed",
    fileDeleteFailed: "Failed to delete file",
    contractDeleteFailed: "Failed to delete contract",
    createQuotationAnalysisTable:
      "Create Quotation Analysis Table (Bind Quotation)",
    management: "Project Management",
    list: "Project List",
    add: "Add Project",
    edit: "Edit Project",
    view: "View Project",
    quotationStage: "Quotation Stage",
    editQuotationStage: "Edit Quotation Stage",
    projectManagement: "Project Management",
    projectName: "Project Name",
    quotationDate: "Quotation Date",
    partnerCompany: "Partner Company",
    projectRemarks: "Project Remarks",
    partnerAddress: "Partner Address",
    contactInfo: "Contact Information",
    save: "Save",
    cancel: "Cancel",
    create: "Create",
    submitEdit: "Submit Edit",
    delete: "Delete",
    errorFetchingData: "Error fetching quotation data:",
    errorFetchingPartnerData: "Error fetching partner data:",
    uploadError: "Error uploading file:",
    csvParsingError: "CSV Parsing Error:",
    saveSuccess: "Project information saved successfully",
    createSuccess: "Project created successfully",
    updateSuccess: "Project updated successfully",
    deleteSuccess: "Project deleted successfully",
    requiredField: "This field is required",
    createProjectList: "Create Project List",
    createProjectListSuccess: "Project list created successfully!",
    confirm: "Confirm",
    addProject: "Add Project",
    searchName: "Search name",
    selectDate: "Select date",
    searchPartner: "Search partner",
    searchFile: "Search file name",
    allFolders: "All folders",
    searchResults: "Search results",
    noMatchedFiles: "No files match your filter",
    search: "Search",
    clear: "Clear",
    progressManagement: "Progress Management",
    progressDetail: "Progress Detail",
    processedComponents: "Processed Components",
    noProgressData: "No progress data",
    thresholdSettings: "Progress Threshold Settings",
    lowThreshold: "Low Threshold (Red)",
    highThreshold: "High Threshold (Green)",
    uploadErrorTitle: "Upload Error",
    deleteSuccessTitle: "Delete Success",
    deleteErrorTitle: "Delete Error",
    meetingRecords: "H. Meeting Records",
    importantNotes: "I. Important Notes",
    validationError: "Validation Error",
    pleaseSelectPartner: "Please select a partner",
    archive: "Archive",
    archived: "Archived",
    archiveProject: "Archive Project",
    archiveDescription: "Archiving moves this project to the Archived list and locks it from further edits (including production plan saves). This cannot be undone.",
    archiveConfirmTitle: "Archive this project?",
    archiveConfirmContent: "Once archived, this project can no longer be edited and cannot be unarchived. Continue?",
    archiveSuccess: "Project archived",
    archiveFailed: "Failed to archive project",
    archivedHint: "This project is archived and can no longer be edited.",
    noArchivedProjects: "No archived projects",
  },
  header: {
    backToCompanyList: "Back to Company Information",
    logout: "Logout",
    notSet: "Not Set",
    updatePassword: "Update Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm New Password",
    passwordMismatch: "New passwords do not match",
    passwordUpdateSuccess: "Password updated successfully",
    passwordUpdateFailed: "Failed to update password",
  },
  notificationCenter: {
    title: "Notifications",
    tabAll: "All",
    tabUnread: "Unread",
    markAllRead: "Mark all as read",
    markRead: "Mark as read",
    markUnread: "Mark as unread",
    empty: "No notifications yet",
    justNow: "Just now",
    minutesAgo: "{{count}} min ago",
    hoursAgo: "{{count}} hr ago",
    daysAgo: "{{count}} day(s) ago",
    fallbackTitle: "Notification",
    loadError: "Failed to load notifications",
    updateError: "Failed to update notification",
    navigateError: "Unable to open the source page",
    types: {
      purchaseOrder: {
        pendingApproval: {
          title: "Purchase order pending approval",
          description: "A purchase order is waiting for your approval.",
        },
      },
      productInventory: {
        belowSafetyStock: {
          title: "Inventory below minimum",
          description:
            "Some items have fallen below the safety stock level. Please restock soon.",
        },
      },
      accountsPayableDetail: {
        paymentDueReminder: {
          title: "Payable due reminder",
          description:
            "A payable is due soon. Please mind the payment deadline.",
        },
      },
      accountsReceivableDetail: {
        paymentDueReminder: {
          title: "Receivable due reminder",
          description:
            "A receivable is due soon. Please follow up on collection.",
        },
      },
      accountsReceivable: {
        billingDueReminder: {
          title: "Billing date reminder",
          description:
            "A receivable has reached its billing date. Please arrange billing.",
        },
        performanceBondRetrievalReminder: {
          title: "Performance bond retrieval reminder",
          description:
            "A performance bond has reached its retrieval date. Please arrange retrieval.",
        },
        warrantyBondRetrievalReminder: {
          title: "Warranty bond retrieval reminder",
          description:
            "A warranty bond has reached its retrieval date. Please arrange retrieval.",
        },
        engineeringInsuranceExpiryReminder: {
          title: "Engineering insurance expiry reminder",
          description:
            "An engineering insurance policy is about to expire. Please renew.",
        },
      },
    },
    samples: {
      approval: {
        title: "Purchase order pending review",
        description: "A new purchase order is waiting for your review.",
      },
      inventory: {
        title: "Stock below lower limit",
        description:
          "Some items are below the safety stock level. Please restock soon.",
      },
      finance: {
        title: "Payment due reminder",
        description:
          "A payable is approaching its due date. Please check the payment deadline.",
      },
      hr: {
        title: "HR update notice",
        description: "New employee onboarding records have been created.",
      },
      system: {
        title: "System maintenance notice",
        description:
          "The system will undergo routine maintenance soon and may be briefly unavailable.",
      },
    },
  },
  employee: {
    basicInfo: "Basic Information",
    birthday: "Birthday",
    bloodType: "Blood Type",
    idNumber: "ID Number",
    licenses: "Licenses",
    motorcycle: "Motorcycle",
    car: "Car",
    has: "Yes",
    hasNot: "No",
    contactAddress: "Contact Address",
    city: "City",
    district: "District",
    postalCode: "Postal Code",
    address: "Address",
    contactInfo: "Contact Information",
    email: "Email / Account",
    phone: "Phone",
    emergencyContact: "Emergency Contact",
    relationship: "Relationship",
    emergencyPhone: "Emergency Contact Phone",
    notes: "Notes",
    gender: {
      male: "Male",
      female: "Female",
      unknown: "Unknown",
    },
    management: {
      noEmployees: "You haven't added any employee data yet! You can try:",
      templateExcel: "Template Excel",
      manualAdd: "Manual Add",
      addEmployee: "Add Employee",
      searchPlaceholder: "Search employees...",
      errorFetchingData: "Error fetching company data:",
    },
    edit: {
      title: "Edit Employee",
      editTitle: "Edit {{name}}",
      reinstate: "Reinstate",
      resign: "Resign",
      saveChanges: "Save Changes",
      resignedReadOnly: "This employee has resigned. Data is read-only.",
      subtitle: "Edit basic employee information.",
      basicData: "Basic Data",
      confirmResignTitle: "Confirm Resignation",
      confirmResignContent:
        "Are you sure you want to set {{name}} as resigned? This will clear all authorizations for this employee.",
      confirmResignOk: "Confirm Resignation",
      bloodTypePlaceholder: "Select Blood Type",
      bloodTypeA: "Type A",
      bloodTypeB: "Type B",
      bloodTypeAB: "Type AB",
      bloodTypeO: "Type O",
      notesPlaceholder: "Enter notes...",
      tags: "Employee Tags",
      selectExistingTag: "Select Existing Tag",
      newTagPlaceholder: "Add custom tag...",
      createTag: "Create",
      name: "Name",
      gender: "Gender",
      birthday: "Birthday",
      bloodType: "Blood Type",
      idNumber: "ID Number",
      licenses: "Licenses",
      motorcycle: "Motorcycle",
      car: "Car",
      has: "Yes",
      hasNot: "No",
      contactAddress: "Contact Address",
      city: "City",
      district: "District",
      postalCode: "Postal Code",
      address: "Address",
      contactInfo: "Contact Information",
      email: "Email",
      emergencyContact: "Emergency Contact",
      relationship: "Relationship",
      emergencyPhone: "Emergency Contact Phone",
      notes: "Notes",
      save: "Save",
      cancel: "Cancel",
      confirmCancel: "Are you sure you want to cancel?",
      errorFetchingData: "Error fetching employee data:",
    },
    signature: {
      title: "Signature",
      hint: "The background is removed automatically after upload. Your signature is protected by a signature password and only you can view it.",
      selfOnly: "Only the employee can set their own signature after signing in.",
      addHint: "The employee sets their signature after signing in, from their own profile edit.",
      locked: "Signature is password protected. Enter your signature password to view it",
      notUploaded: "No signature uploaded yet.",
      view: "View Signature",
      upload: "Upload Signature",
      replace: "Replace Signature",
      changePassword: "Change Signature Password",
      password: "Signature Password",
      currentPassword: "Current Signature Password",
      newPassword: "New Signature Password",
      confirmPassword: "Confirm Signature Password",
      firstUploadHint: "On first upload this becomes your signature password. If you already set one, enter your current signature password.",
      oldPasswordRequired: "Enter your current signature password",
      passwordTooShort: "Signature password must be at least {{min}} characters",
      passwordMismatch: "Passwords do not match",
      passwordIncorrect: "Incorrect signature password",
      passwordChanged: "Signature password updated",
      forbidden: "You don't have permission to manage signatures",
      requestFailed: "Signature request failed. Please try again later",
      original: "Original",
      processed: "Background Removed",
      sensitivity: "Removal Strength",
      processing: "Processing…",
      rotateLeft: "Rotate left",
      rotateRight: "Rotate right",
      inkColor: "Ink colour",
      inkOriginal: "Original",
      inkBlack: "Black",
      inkBlue: "Blue",
      resetSensitivity: "Reset to suggested",
      eraser: "Manual eraser",
      eraserDone: "Done erasing",
      eraserHint: "Paint over leftover specks or shadows with your finger, pen or mouse. Erased areas stay when you change strength or ink colour. Finish erasing before rotating.",
      brushSize: "Brush size",
      brushSmall: "S",
      brushMedium: "M",
      brushLarge: "L",
      undo: "Undo",
      restoreAll: "Restore all",
      sensitivityHint: "Raise it if background remains; lower it if strokes break up or fade.",
      emptyResult: "Nothing left after background removal. Lower the removal strength",
      invalidFile: "Please choose an image file",
      fileTooLarge: "Image must be 10MB or smaller",
      uploadSuccess: "Signature saved",
      confirm: "Confirm",
      save: "Save",
    },
    add: {
      title: "Add Employee",
      cancel: "Cancel",
      submit: "Add",
      accountInfo: "Account Information",
      emailPlaceholder: "Enter Email",
      namePlaceholder: "Enter name",
      emailRequired: "Please enter Email",
      addFailed: "Failed to add employee",
      selectTags: "Select Tags",
    },
    list: {
      searchPlaceholder: "Search employee name or email...",
      filterByTag: "Filter by Tag",
      noTags: "No Tags",
      activeSection: "Active Employees",
      noResults: "No employees match the criteria",
      resignedSection: "Resigned Employees",
      noResigned: "No resigned employee records",
    },
    page: {
      employeeListTab: "Employee List",
      permissionOverviewTab: "Permission Overview",
      permissionTitle: "Permission Distribution Overview",
      permissionHint:
        "Click icon to toggle authorization status, then click Save to confirm",
      licensesTab: "License Quota",
      invoiceTab: "Invoices",
      invoice: {
        profileTitle: "Invoice Details",
        editProfile: "Edit",
        profileNotSet: "No invoice details yet. Fill them in before invoices are issued.",
        type: "Invoice Type",
        types: { b2b: "Triplicate (Company)", b2c: "Duplicate (Individual)" },
        title: "Buyer Name",
        titleRequired: "Please enter the buyer name",
        taxId: "Tax ID (UBN)",
        taxIdInvalid: "Invalid tax ID",
        email: "Invoice Email",
        emailRequired: "Please enter the invoice email",
        emailInvalid: "Invalid email format",
        address: "Mailing Address",
        historyTitle: "Invoice History",
        empty: "No invoices yet",
        number: "Invoice No.",
        createdAt: "Created",
        item: "Item",
        seatOrderItem: "Seat subscription",
        subtotal: "Subtotal",
        tax: "Tax",
        total: "Total",
        status: "Status",
        statuses: { pending: "Pending", issued: "Issued", void: "Void" },
        download: "Download invoice",
      },
      pendingNotEffective: "not yet in effect",
      seat: {
        pricingNote: "Billed monthly per seat. Add or remove seats anytime (not below seats in use).",
        perSeatMonth: "/ seat / month",
        pools: {
          general: {
            name: "General seats",
            description: "Shared by Inventory, Procurement, Finance, Procurement Manager and Project Management; reassign freely",
          },
          projectReport: { name: "Project Report seats", description: "Project report access permissions" },
          admin: { name: "Admin seats", description: "System admin permissions" },
        },
        interchangeable: " (interchangeable)",
        allocated: "Allocated",
        fullyAllocated: "All seats allocated",
        unassigned: "{{n}} seats unallocated",
        overAllocated: "{{n}} over the total, reduce allocations",
        totalSeats: "Total seats",
        standaloneTitle: "Standalone seats",
        standaloneHint: "Billed separately; not interchangeable with general seats.",
        allocatedSeats: "Allocated seats",
        seatCount: "Seats",
        originalSeats: "Was {{n}}",
        minimum: "min {{n}}",
        decrease: "Decrease {{label}} seats",
        increase: "Increase {{label}} seats",
        inputLabel: "{{label}} seats",
        totalAfter: "{{n}} seats after adjustment",
        allocationOnly: "General seat allocation only, no price change",
        unassignedNotice: "{{n}} general seats unallocated; you can check out now and allocate later",
        overNotice: "Role allocations exceed general seats by {{n}}; reduce allocations",
        monthlyAfter: "Monthly after adjustment (incl. tax)",
        vsCurrent: "{{amount}} vs. current",
        reset: "Reset",
        checkout: "Checkout",
        saveAllocation: "Save allocation",
        allocationSaved: "Seat allocation saved",
        confirmTitle: "Confirm seat changes",
        confirmDesc: "Billed per seat, renews monthly; add or remove seats anytime.",
        plan: "Plan",
        seats: "Seats",
        monthlyAmount: "Monthly",
        unchanged: "Unchanged",
        originalDelta: "Was {{current}} ({{delta}})",
        allocationChanges: "General seat allocation changes",
        subtotalSeats: "Subtotal ({{n}} seats)",
        tax: "Sales tax ({{rate}}%)",
        totalMonthly: "Monthly total after adjustment",
        currentMonthly: "Currently {{amount}} / month",
        difference: "Difference {{amount}}",
        unassignedCheckout: "{{n}} general seats are not allocated to a role. They are still billed and can be allocated after checkout.",
        back: "Back",
        confirmCheckout: "Confirm checkout",
        orderCreated: "Order created",
        orderId: "Order no.",
        orderCreatedDesc: "New monthly total {{amount}}. Online payment isn't available yet; seats take effect once activated.",
        allocationDeferred: "Allocations beyond the current seat count will apply once the new seats take effect.",
        done: "Done",
        pendingTitle: "Pending seat order",
        pendingAllocation: "Pending allocation",
        cancelOrder: "Cancel order",
        allocationExceeded: "Allocations exceed the seat count; you can only reduce them",
        allocationBelowUsed: "Allocation can't be lower than the seats in use for that role",
        saveFailed: "Save failed",
      },
      subscriptionTitle: "Subscription expiry date",
      subscriptionEdit: "Set",
      subscriptionPeriod: "Subscription period",
      subscriptionNotSet: "Subscription period not set",
      subscriptionDaysLeft: "{{days}} days left",
      subscriptionExpired: "Expired",
      confirm: "OK",
      cancel: "Cancel",
      available: "Available",
      depleted: "Depleted",
      usageStatus: "Usage",
      permissionEmployeeColumn: "Employee",
      permissionRoleColumn: "Role",
      orgRoleOwner: "Owner",
      orgRoleAdmin: "Admin",
      orgRoleMember: "Member",
      needAdminPermission: "Admin permission required",
      quotaFull: "Authorization quota reached",
      seatQuotaFull: "No seats left in this pool; add seats or adjust allocations",
      clickToRevoke: "Click to revoke authorization",
      clickToGrant: "Click to grant authorization",
      loadFailed: "Failed to load data",
      operationFailed: "Operation failed",
      roles: {
        admin: { name: "Admin", description: "System admin permissions" },
        project: {
          name: "Project Management",
          description: "Project management permissions",
        },
        projectReport: {
          name: "Project Report",
          description: "Project report access permissions",
        },
        purchase: {
          name: "Procurement",
          description: "Procurement process management permissions",
        },
        purchaseManager: {
          name: "Procurement Manager",
          description: "Purchase order approval permissions",
        },
        inventory: {
          name: "Inventory",
          description: "Inventory management permissions",
        },
        finance: {
          name: "Finance",
          description: "Financial data access permissions",
        },
      },
    },
  },
  companyList: {
    title: "Company List",
    backToLogin: "Back to Login",
    selectCompany: "Select the company you want to start or view:",
    recentlyOpened: "Recently Opened",
    yourCompanies: "Your Companies",
    addCompany: "Your Companies",
    businessIdNumber: "Business ID",
  },
  productionPlan: {
    materialSpec: "Material Spec - Diameter - Length",
    type: "Type",
    quantity: "Quantity",
    material: "Material",
    unitWeight: "Unit Weight (kg/m)",
    navigationOne: "Navigation One",
    navigationTwo: "Navigation Two",
    navigationThree: "Navigation Three",
    option1: "Option 1",
    option2: "Option 2",
    option3: "Option 3",
    option4: "Option 4",
    submenu: "Submenu",
    submenu2: "Submenu 2",
    sortByComponentCode: "Component Code (A-Z)",
    sortByComponentId: "Component ID (A-Z)",
    designBOM: "Design BOM",
    productionResume: "Production Resume",
    aiAssistant: "AI Assistant",
    showQRCode: "Show QR code",
    productionPlanTable: "Production Plan Table",
    order: "Order",
    production: "Production",
    bomTable: "BOM Table",
    processSettings: "Process Settings",
    sectionSpecification: "Section Specification",
    boltBOM: "Bolt BOM",
    cancel: "Cancel",
    ok: "OK",
  },
  textUpdateNode: {
    updateSuccess: "Update successful",
    nodeNameUpdated: "Node name updated",
    updateFailed: "Update failed",
    cannotUpdateNodeName: "Cannot update node name",
    workItemSettings: "Work Item Settings",
    addWorkItem: "Add Work Item",
    pendingComponents: "Pending Components",
    completedComponents: "Completed Components",
    componentList: "Component List",
    planBom: "Production Plan BOM",
    selectComponents: "Select Components",
    manualAddComponent: "Manual Add Component",
    cancel: "Cancel",
    confirmAdd: "Confirm Add",
    addNewWorkItem: "Add New Work Item",
    workItemSelection: "Work Item Selection",
    enterWorkItemName: "Please enter work item name",
    personnelSelection: "Personnel Selection",
    selectPersonnel: "Please select personnel",
    scanPassCount: "Scan Pass Count",
    multiple: "Multiple",
    single: "Single",
    all: "All",
    selectScanPassCount: "Please select scan pass count",
    addNewComponent: "Add New Component",
    componentId: "Component ID",
    enterComponentId: "Please enter component ID",
    componentCode: "Component Code",
    enterComponentCode: "Please enter component code",
    guandaId: "Guanda ID",
    enterGuandaId: "Please enter Guanda ID",
    installationLocation: "Installation Location",
    enterInstallationLocation: "Please enter installation location",
    installationElevation: "Installation Elevation",
    enterInstallationElevation: "Please enter installation elevation",
    distinction: "Distinction",
    enterDistinction: "Please enter distinction",
    transportNumber: "Transport Number",
    enterTransportNumber: "Please enter transport number",
    transportDescription: "Transport Description",
    enterTransportDescription: "Please enter transport description",
    drawingName: "Drawing Name",
    enterDrawingName: "Please enter drawing name",
    totalWidth: "Total Width",
    enterTotalWidth: "Please enter total width",
    totalHeight: "Total Height",
    enterTotalHeight: "Please enter total height",
    totalLength: "Total Length",
    enterTotalLength: "Please enter total length",
    totalWeight: "Total Weight",
    totalWeightSingle: "Total Weight (per unit)",
    enterTotalWeight: "Please enter total weight",
    totalArea: "Total Area",
    enterTotalArea: "Please enter total area",
    metricSizeMark: "Section Specification",
    enterMetricSizeMark: "Please enter section specification",
    // Error handling messages
    error: "Error",
    warning: "Warning",
    success: "Success",
    fetchError: "Loading Failed",
    createFailed: "Creation Failed",
    noDocumentId: "Node ID not found, unable to update component list",
    noProjectId: "Project ID not found, unable to add component",
    noBuildingNode: "Building node not found, unable to add component",
    noSelectedComponents: "Please select at least one component",
    componentIdRequired: "Component ID is required",
    componentCodeRequired: "Component Code is required",
    workItemNameRequired: "Please enter work item name",
    employeeRequired: "Please select at least one employee",
    noEmployeeData: "No employee data",
    noNodeData: "Unable to retrieve node data",
    fetchMaterialBomError:
      "Unable to load component list data, please try again later",
    updateSteelAssemblyError:
      "Unable to update component list, please try again later",
    fetchNodeDataError: "Unable to load node data, please try again later",
    fetchEmployeeError: "Unable to load employee data, please try again later",
    fetchComponentDataError: "Unable to retrieve new component details",
    createComponentError:
      "Unable to create new component, please try again later",
    addComponentError: "Unable to add component, please try again later",
    workItemCreateError: "Unable to create work item, please try again later",
    componentsAddedSuccess: "Components added successfully",
    componentAddedSuccess: "Component added successfully",
    workItemCreatedSuccess: "Work item created successfully",
    createWorkItemError: "Unable to create work item, please try again later",
    actions: "Actions",
    remove: "Remove",
    removeFailed: "Remove Failed",
    componentRemovedSuccess: "Component removed successfully",
    removeSteelAssemblyError:
      "Unable to remove component, please try again later",
    workerName: "Worker",
    status: "Status",
    reportDate: "Report Date",
    viewRecords: "View Records",
    statusCompleted: "Completed",
    statusError: "Error",
    statusNotReported: "Not Reported",
    showColumns: "Show Columns",
  },
  dragDropList: {
    scanMode: "Scan Mode",
    personnelSelection: "Personnel Selection",
    scanRecord: "Scan Record",
    editWorkItem: "Edit Work Item",
    deleteWorkItem: "Delete Work Item",
    noScanRecord: "No scan records",
    reportItems: "Report Items",
    noReportItems: "No report items",
    reportPerson: "Reporter",
    reportStatus: "Report Status",
    reportComponent: "Reported Components",
    reportTime: "Report Time",
    statusSuccess: "Success",
    statusError: "Error",
    componentsCount: "components",
    scanModeMultiple: "Multiple",
    scanModeSingle: "Single",
    scanModeAll: "All",
    cancel: "Cancel",
    confirmEdit: "Confirm Edit",
    confirmDelete: "Confirm Delete",
    deleteConfirmTitle: "Confirm Delete Work Item",
    deleteConfirmMessage: "Are you sure you want to delete work item",
    workItemSelection: "Work Item Selection",
    enterWorkItemName: "Please enter work item name",
    selectPersonnel: "Please select personnel",
    scanPassCount: "Scan Pass Count",
    selectScanPassCount: "Please select scan pass count",
    action: "Action",
    revokeReport: "Revoke Report",
    revoked: "Revoked",
    confirmRevoke: "Confirm Revoke",
    revokeConfirmTitle: "Confirm Revoke Report",
    revokeConfirmMessage:
      "Are you sure you want to revoke this report record? Component status will be recalculated after revoking.",
  },
  workItemDialog: {
    createTitle: "Add Work Item",
    editTitle: "Edit Work Item",
    close: "Close",
    workItemSelection: "Work Item",
    enterWorkItemName: "Enter work item name",
    personnelSelection: "Personnel",
    multiSelectHint: "Multiple allowed",
    selectPersonnel: "Select personnel",
    noPersonnel: "No personnel available",
    morePersons: "and {{count}} in total",
    remove: "Remove",
    scanPassCount: "Scan Pass Count",
    scanModeMultiple: "Multiple",
    scanModeSingle: "Single",
    scanModeAll: "All",
    reportItems: "Report Items",
    reportItemsHint:
      "Select the items operators need to report (multiple allowed, no limit)",
    reportItemsNote:
      "Preset items are selectable only; custom items can be edited or deleted after being added.",
    // limitReached: "Limit of {{max}} reached",
    addCustomItem: "Add custom item",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    finishEdit: "Finish editing",
    itemsSelected: "{{count}} item(s) selected",
    cancel: "Cancel",
    confirmAdd: "Confirm",
    saveChanges: "Save Changes",
  },
  accountPayable: {
    title: "Accounts Payable",
    searchPlaceholder: "Search name, partner, project or remarks...",
    addAccountPayable: "Add Accounts Payable",
    editAccountPayable: "Edit Accounts Payable",
    name: "Name",
    totalAmount: "Total Amount Payable",
    unpaidAmount: "Unpaid Amount (Tax Incl.)",
    paidAmount: "Paid Amount",
    status: "Status",
    partner: "Partner",
    bank: "Bank",
    project: "Project",
    remarks: "Remarks",
    edit: "Edit",
    delete: "Delete",
    basicInfo: "Basic Information",
    accountPayableName: "Accounts Payable Name",
    paymentStatus: "Status",
    fullPayment: "Full Payment",
    installPayment: "Installment Payment",
    partnerSupplier: "Partner/Supplier",
    sourceRemarks: "Source Remarks",
    paymentRecord: "Payment Record",
    addPaymentRecord: "Add Payment Record",
    noPaymentData: "No payment data",
    requestedAmount: "Payable Amount",
    taxRate: "Tax Rate (%)",
    paymentMethod: "Payment Method",
    transfer: "Transfer",
    check: "Check",
    cash: "Cash",
    credit: "Credit Card",
    paymentDate: "Payment Date",
    paymentAmount: "Payment Amount",
    invoiceNumber: "Invoice Number",
    invoiceDate: "Invoice Date",
    dueDate: "Due Date",
    cancel: "Cancel",
    add: "Add",
    confirmDelete: "Confirm Delete",
    confirmDeleteContent:
      "Are you sure you want to delete this accounts payable? This action cannot be undone.",
    confirm: "Confirm",
    deleteSuccess: "Delete Successful",
    deleteSuccessDesc: "Accounts payable has been successfully deleted",
    deleteFailed: "Delete Failed",
    deleteError: "An error occurred while deleting accounts payable",
    fillRequired: "Please fill in required fields",
    missingFields:
      "Payment record #{{number}} is missing the following required fields:",
    updateDetailFailed: "Failed to update payment detail",
    createDetailFailed: "Failed to create payment detail",
    updateFailed: "Update failed",
    createFailed: "Failed to create accounts payable",
    enterName: "Enter name",
    enterPartnerName: "Enter partner name",
    records: "records",
    clickToAddPayment: "Click the button above to add payment record",
    paymentRecordNumber: "Payment Record #{{number}}",
    exportExcel: "Export Excel",
    documentRecords: "Document Records",
    retrieved: "Retrieved",
    performanceGuarantee: "Performance Guarantee",
    constructionInsurance: "Construction Insurance",
    warrantyBond: "Warranty Bond",
    voucherNumber: "Voucher Number",
    retrievalDate: "Retrieval Date",
    enterVoucherNumber: "Please enter voucher number",
    retrievedGuarantee: "Performance Guarantee Retrieved",
    retrievedWarrantyBond: "Warranty Bond Retrieved",
    startDate: "Start Date",
    expirationDate: "Expiration Date",
    checkNumber: "Check Number",
    checkClearanceDate: "Check Clearance Date",
    handlingFee: "Handling Fee",
    retentionAmount: "Retention Amount",
    deductionAmount: "Deduction Amount",
    netAmount: "Net Payment Amount",
    totalHandlingFee: "Total Handling Fee",
    totalDeductionAmount: "Total Deduction Amount",
    taxAmount: "Tax Amount",
    totalAmountWithTax: "Total Amount (incl. Tax)",
    isSettled: "Settled",
    totalRetentionAmount: "Total Retention",
    inProgressAmount: "In-Progress Amount",
    selected: "Selected",
  },
  accountReceivable: {
    title: "Accounts Receivable",
    searchPlaceholder: "Search name, partner, project or remarks...",
    addAccountReceivable: "Add Accounts Receivable",
    editAccountReceivable: "Edit Accounts Receivable",
    name: "Name",
    totalAmount: "Total Amount Receivable",
    unpaidAmount: "Uncollected Amount (Tax Incl.)",
    paidAmount: "Collected Amount",
    totalRetentionAmount: "Total Retention",
    inProgressAmount: "In-Progress Amount",
    status: "Status",
    partner: "Partner",
    bank: "Bank",
    project: "Project",
    remarks: "Remarks",
    edit: "Edit",
    delete: "Delete",
    basicInfo: "Basic Information",
    accountReceivableName: "Accounts Receivable Name",
    paymentStatus: "Status",
    fullPayment: "Full Payment",
    installPayment: "Installment Payment",
    partnerSupplier: "Partner/Supplier",
    sourceRemarks: "Source Remarks",
    collectionRecord: "Collection Record",
    addCollectionRecord: "Add Collection Record",
    noCollectionData: "No collection data",
    collectionDate: "Collection Date",
    collectionAmount: "Collection Amount",
    invoiceNumber: "Invoice Number",
    invoiceDate: "Invoice Date",
    dueDate: "Due Date",
    cancel: "Cancel",
    requestedAmount: "Receivable Amount",
    taxRate: "Tax Rate (%)",
    paymentMethod: "Payment Method",
    transfer: "Transfer",
    check: "Check",
    cash: "Cash",
    credit: "Credit Card",
    confirmDelete: "Confirm Delete",
    confirmDeleteContent:
      "Are you sure you want to delete this accounts receivable? This action cannot be undone.",
    confirm: "Confirm",
    deleteSuccess: "Delete Successful",
    deleteSuccessDesc: "Accounts receivable has been successfully deleted",
    deleteFailed: "Delete Failed",
    requiredFields: "Please fill in required fields",
    collectionRecordMissingDesc:
      "Collection Record #{{index}} is missing the following required fields:",
    listSeparator: ", ",
    updateDetailFailed: "Failed to update collection details",
    addDetailFailed: "Failed to add collection details",
    updateFailed: "Update Failed",
    records: "records",
    clickToAddRecord: "Click the button above to add collection records",
    collectionRecordLabel: "Collection Record #",
    enterName: "Please enter name",
    enterPartner: "Please enter partner name",
    enterRemarks: "Remarks",
    exportExcel: "Export Excel",
    filterByDate: "Filter by Collection Date",
    startDate: "Start Date",
    endDate: "End Date",
    documentRecords: "Document Records",
    retrieved: "Retrieved",
    performanceGuarantee: "Performance Guarantee",
    constructionInsurance: "Construction Insurance",
    warrantyBond: "Warranty Bond",
    voucherNumber: "Voucher Number",
    retrievalDate: "Retrieval Date",
    enterVoucherNumber: "Please enter voucher number",
    retrievedGuarantee: "Performance Guarantee Retrieved",
    retrievedWarrantyBond: "Warranty Bond Retrieved",
    expirationDate: "Expiration Date",
    checkNumber: "Check Number",
    checkClearanceDate: "Check Clearance Date",
    handlingFee: "Handling Fee",
    retentionAmount: "Retention Amount",
    deductionAmount: "Deduction Amount",
    netAmount: "Net Collection Amount",
    totalHandlingFee: "Total Handling Fee",
    totalDeductionAmount: "Total Deduction Amount",
    taxAmount: "Tax Amount",
    totalAmountWithTax: "Total Amount (incl. Tax)",
    isSettled: "Settled",
    selected: "Selected",
  },
  bank: {
    title: "Bank",
    addBank: "Add Bank",
    editBank: "Edit Bank",
    name: "Bank Name",
    bankName: "Bank Name",
    balance: "Balance",
    remarks: "Remarks",
    edit: "Edit",
    confirm: "Confirm",
    cancel: "Cancel",
    requiredField: "Please fill in required fields",
    nameRequired: "Bank name is required",
    addSuccess: "Added successfully",
    bankAdded: "Bank has been added",
    updateSuccess: "Updated successfully",
    bankUpdated: "Bank data has been updated",
    addFailed: "Failed to add",
    updateFailed: "Failed to update",
    enterBankName: "Please enter bank name",
    enterBalance: "Please enter balance",
    enterRemarks: "Please enter remarks",
  },
  bankManagement: {
    title: "Bank Management",
    addBankNode: "Add Bank Node",
    selectBank: "Select Bank",
    addReceivable: "Add Receivable",
    addPayable: "Add Payable",
    selectReceivable: "Select Accounts Receivable",
    selectPayable: "Select Accounts Payable",
    noData: "No Data",
    receivable: "Receivable",
    payable: "Payable",
    income: "Income",
    expense: "Expense",
    cancel: "Cancel",
    confirm: "Confirm",
    insufficientBalance: "Insufficient Balance",
  },
  designBOM: {
    validationError: "Invalid data format",
    uploadSuccess: "Successfully imported {{count}} design BOM records",
    uploadError: "An error occurred during upload. Please try again later.",
    componentId: "Component ID",
    guandaId: "Guanda ID",
    componentCode: "Component Code",
    installationLocation: "Installation Location",
    installationElevation: "Installation Elevation",
    distinction: "Distinction",
    transportNumber: "Transport Number",
    transportDescription: "Transport Description",
    drawingName: "Drawing Name",
    model3d: "3D Model",
    view3d: "View 3D",
    pick3dFile: "Pick file",
    totalWidth: "Total Width",
    totalHeight: "Total Height",
    totalLength: "Total Length",
    totalWeight: "Total Weight",
    totalArea: "Total Area",
    sectionSpecification: "Section Specification",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    deleteSelected: "Delete Selected Items",
    exportGuandaId: "Export Guanda ID",
    uploadIfc: "Upload IFC",
    uploadIfcSuccess: "IFC uploaded",
    uploadIfcError: "IFC upload failed",
    projectNotFound: "Could not find the project this assembly belongs to",
    ifcAnalyzing: "Analysing IFC…",
    ifcAnalyzed: "IFC analysed",
    ifcAnalyzeFailed: "IFC analysis failed",
    importComponent: "Import Component",
    manualAddBOM: "Manual Add BOM",
    summaryCompact: "{{selected}} / {{total}} selected",
    summaryTotal: "{{count}} pcs total",
    summarySelected: "{{count}} selected",
    summaryWeight: "{{weight}} kg total",
    searchGuandaId: "Search Guanda ID",
    searchComponentCode: "Search Component Code",
    searchDistinction: "Search Distinction",
    searchTransportNumber: "Search Transport Number",
    searchSectionSpec: "Search Section Specification",
    search: "Search",
    clear: "Clear",
    editSuccess: "Edit Successful",
    editFailed: "Edit Failed",
    deleteSuccess: "Delete Successful",
    noItemsToDelete: "Please select items to delete",
    noChangesToUpdate: "No changes to update",
    parameterSettings: "Parameter Settings",
    download: "Download",
    paramA: "Parameter A - Train",
    paramB: "Parameter B - Component Code",
    paramC: "Parameter C",
    option1: "Option 1",
    option2: "Option 2",
    option3: "Option 3",
    option4: "Option 4",
    option5: "Option 5",
    none: "None",
    train: "Train",
    character: "Character",
    enterCharacter: "Enter Character",
    printQRCode: "Print QR Code",
    notPrintQRCode: "Do Not Print QR Code",
    shouldPrintQRCode: "Print QR Code?",
    noData: "No Data",
    downloadFailed: "Download Failed",
    cannotFetchData: "Cannot fetch all data, please try again later",
    manualAddBOMTitle: "Manual Add BOM",
    add: "Add",
    enterComponentId: "Please enter Component ID",
    enterComponentCode: "Please enter Component Code",
    enterInstallationLocation: "Please enter Installation Location",
    enterInstallationElevation: "Please enter Installation Elevation",
    enterDistinction: "Please enter Distinction",
    enterTransportNumber: "Please enter Transport Number",
    enterTransportDescription: "Please enter Transport Description",
    enterDrawingName: "Please enter Drawing Name",
    enterTotalWidth: "Please enter Total Width",
    enterTotalHeight: "Please enter Total Height",
    enterTotalLength: "Please enter Total Length",
    enterTotalWeight: "Please enter Total Weight",
    enterTotalArea: "Please enter Total Area",
    enterSectionSpec: "Please enter Section Specification",
    manualAddSuccess: "Manual add BOM successful",
    manualAddFailed: "Manual add BOM failed, please check input data",
    manualAddError: "Manual add BOM failed, please try again later",
    showColumns: "Show Columns",
    showAllColumns: "Show all",
    hideAllColumns: "Hide all",
    exportFailed: "Export Failed",
    noItemsToExport: "Please select items to export first",
  },
  steelAssemblyBOM: {
    uploadSuccess: "Successfully imported {{count}} steel assembly BOM records",
    uploadPartialError: "Upload failed: {{failed}} records could not be saved, {{success}} succeeded",
    uploadError: "An error occurred during upload. Please try again later.",
    title: "Steel Assembly BOM",
    showColumns: "Show Columns",
    componentId: "Component ID",
    guandaId: "Guanda ID",
    componentCode: "Component Code",
    installationLocation: "Installation Location",
    installationElevation: "Installation Elevation",
    distinction: "Distinction",
    transportNumber: "Transport Number",
    transportDescription: "Transport Description",
    drawingName: "Drawing Name",
    totalWidth: "Total Width",
    totalHeight: "Total Height",
    totalLength: "Total Length",
    totalWeight: "Total Weight",
    totalArea: "Total Area",
    sectionSpecification: "Section Specification",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    deleteSelected: "Delete Selected Items",
    importComponent: "Import Component",
    searchGuandaId: "Search Guanda ID",
    searchInstallationLocation: "Search Installation Location",
    searchSectionSpec: "Search Section Specification",
    searchTransportNumber: "Search Transport Number",
    search: "Search",
    clear: "Clear",
    editSuccess: "Edit Successful",
    editFailed: "Edit Failed",
    deleteSuccess: "Delete Successful",
    noItemsToDelete: "Please select items to delete",
    backToDesignBOM: "Back to Design BOM",
    errorFetchingData: "Error fetching steel assembly data:",
    errorUpdatingData: "Error updating steel assembly data:",
    errorDeletingData: "Error deleting steel assembly data:",
    successUpdate: "Successfully updated",
    successDelete: "Successfully deleted",
  },
  steelBoltBOM: {
    uploadSuccess: "Successfully imported {{count}} steel bolt BOM records",
    uploadPartialError: "Upload failed: {{failed}} records could not be saved, {{success}} succeeded",
    uploadError: "An error occurred during upload. Please try again later.",
    partNumber: "Part Number",
    partName: "Part Name",
    material: "Material",
    specification: "Specification",
    quantity: "Quantity",
    unit: "Unit",
    weight: "Weight",
    remarks: "Remarks",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    deleteSelected: "Delete Selected Items",
    importPart: "Import Part",
    search: "Search",
    clear: "Clear",
    editSuccess: "Edit Successful",
    editFailed: "Edit Failed",
    deleteSuccess: "Delete Successful",
    noItemsToDelete: "Please select items to delete",
    searchPartNumber: "Search Part Number",
    searchPartName: "Search Part Name",
    searchMaterial: "Search Material",
    searchSpecification: "Search Specification",
    showColumns: "Show Columns",
  },
  coop: {
    companyName: "Company Name",
    businessIdNumber: "Business ID",
    contactPerson: "Contact Person",
    phone: "Phone",
    email: "E-mail",
    basicInfo: "Basic Information",
    contactInfo: "Contact Information",
    address: "Address",
    city: "City",
    district: "District",
    postalCode: "Postal Code",
    fullAddress: "Full Address",
    businessType: "Business Type",
    representative: "Representative",
    capital: "Capital",
    establishedDate: "Established Date",
    website: "Website",
    notes: "Notes",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
    reviewed: "Reviewed",
    management: "Partner Management",
    list: "Partner List",
    add: "Add Partner",
    edit: "Edit Partner",
    view: "View Partner",
    delete: "Delete Partner",
    search: "Search Partner",
    searchPlaceholder: "Search company name, business ID or contact person...",
    activeSection: "Partners",
    pendingSection: "Pending Partners",
    noResults: "No matching partners found",
    noPending: "No pending partners",
    addNew: "Add New Partner",
    editTitle: "Edit Partner Information",
    viewTitle: "Partner Details",
    pendingManagement: "Pending Partners",
    reviewedManagement: "Deactivated Partners",
    actions: "Actions",
    approve: "Approve",
    reject: "Reject",
    reactivate: "Reactivate",
    deactivate: "Deactivate",
    confirmDelete: "Are you sure you want to delete this partner?",
    confirmDeactivate: "Are you sure you want to deactivate this partner?",
    confirmReactivate: "Are you sure you want to reactivate this partner?",
    deleteSuccess: "Partner deleted successfully",
    deactivateSuccess: "Partner deactivated successfully",
    reactivateSuccess: "Partner reactivated successfully",
    saveSuccess: "Partner information saved successfully",
    errorFetchingData: "Error fetching partner data",
    errorSavingData: "Error saving partner data",
    errorDeletingData: "Error deleting partner data",
    requiredField: "This field is required",
    invalidEmail: "Please enter a valid email address",
    invalidPhone: "Please enter a valid phone number",
    abbreviation: "Abbreviation",
    contactAddress: "Contact Address",
    businessRegisterAddress: "1. Business Registration Address",
    invoiceAddressSection: "2. Invoice Address",
    shippingAddressSection: "3. Shipping Address",
    sameAsBusinessAddress: "Same as Business Registration Address",
    sameAsInvoiceAddress: "Same as Invoice Address",
    basicContactInfo: "1. Basic Contact Information",
    fax: "Fax",
    contactPersonInfo: "2. Contact Person Information",
    department: "Department",
    invoiceType: "Invoice Type",
    cancel: "Cancel",
    confirm: "Confirm",
    addBtn: "Add",
    noPendingData: "You don't have any pending data",
    noReviewedData: "You don't have any deactivated partners",
    backToPartnerList: "Back to Partner List",
    backToDetail: "Back to Partner Details",
    editLockedTitle: "Partner Cannot Be Edited",
    editLockedPending: "This partner is under deactivation review and cannot be edited.",
    editLockedDisabled: "This partner has been deactivated and cannot be edited.",
    createSuccess: "Partner created successfully!",
    addContact: "Add Contact",
    removeContact: "Remove Contact",
    contactNumber: "Contact #{{number}}",
    noContacts: "No contacts added yet",
  },
  purchaseOrder: {
    name: "Name",
    purchaseOrderName: "Purchase Order Name",
    date: "Date",
    purchaseDate: "Purchase Date",
    deliveryDate: "Delivery Date",
    partner: "Partner",
    customer: "Partner (Customer)",
    supplier: "Supplier",
    remarks: "Remarks",
    address: "Address",
    deliveryAddress: "Delivery Address",
    city: "City",
    district: "District",
    postalCode: "Postal Code",
    fullAddress: "Full Address",
    basicInfo: "Basic Information",
    contactInfo: "Contact Information",
    management: "Purchase Order Management",
    draftManagement: "Draft Purchase Orders",
    underReviewManagement: "Purchase Orders Under Review",
    approvedManagement: "Approved Purchase Orders",
    completedManagement: "Completed Purchase Orders",
    rejectedManagement: "Rejected Purchase Orders",
    list: "Purchase Order List",
    add: "Add Purchase Order",
    edit: "Edit Purchase Order",
    view: "View Purchase Order",
    delete: "Delete Purchase Order",
    draft: "Draft",
    underReview: "Under Review",
    approved: "Approved",
    completed: "Completed",
    rejected: "Rejected",
    status: "Status",
    reviewStatus: "Review Status",
    actions: "Actions",
    approve: "Approve",
    reject: "Reject",
    submit: "Submit for Review",
    save: "Save",
    cancel: "Cancel",
    create: "Create",
    update: "Update",
    searchPlaceholder: "Search purchase order name or supplier...",
    totalAmount: "Total Amount",
    quantity: "Quantity",
    unitPrice: "Unit Price",
    productName: "Product Name",
    productCode: "Product Code",
    specifications: "Specifications",
    unit: "Unit",
    confirmDelete: "Are you sure you want to delete this purchase order?",
    confirmSubmit:
      "Are you sure you want to submit this purchase order for review?",
    confirmApprove: "Are you sure you want to approve this purchase order?",
    confirmReject: "Are you sure you want to reject this purchase order?",
    saveSuccess: "Purchase order saved successfully",
    createSuccess: "Purchase order created successfully",
    updateSuccess: "Purchase order updated successfully",
    deleteSuccess: "Purchase order deleted successfully",
    submitSuccess: "Purchase order submitted for review successfully",
    approveSuccess: "Purchase order approved successfully",
    rejectSuccess: "Purchase order rejected successfully",
    errorFetchingData: "Error fetching purchase order data",
    errorSavingData: "Error saving purchase order data",
    errorDeletingData: "Error deleting purchase order data",
    requiredField: "This field is required",
    invalidAmount: "Please enter a valid amount",
    invalidQuantity: "Please enter a valid quantity",
    noPurchaseOrderData:
      "You haven't added purchase order data yet! You can try:",
    manualAdd: "Manual Add",
    createPurchaseOrder: "Create Purchase Order",
    paymentMethod: "Payment Method",
    shippingFeeCalculation: "Shipping Fee Calculation",
    actualShippingFee: "Actual Shipping Fee",
    orderReminderDate: "Order Reminder Date",
    requiresInvoice: "Requires Invoice",
    requiresIncomingQualityControl: "Requires Incoming Quality Control",
    incomingQCItems: "Incoming QC Items",
    addFile: "Add File",
    product: "Product",
    addProductRow: "Add Product Row",
    productNameCode: "Product Name / Code",
    delete: "Delete",
    deliverySettings: "Delivery Settings",
    deliveryMethodSection: "1. Delivery Method",
    deliveryMethodTitle: "Delivery Method",
    deliveryMethodLabel: "Delivery Method*",
    deliveryReceiver: "Delivery Receiver",
    deliveryLocation: "2. Delivery Location",
    deliveryLocationTitle: "Delivery Location",
    deliveryLocationPlaceholder: "Please enter the delivery location",
    remarkNoticeTitle: "Remarks & Notices",
    remark: "Remark",
    remarkPlaceholder: "Please enter remarks",
    notice: "Notice",
    noticePlaceholder: "Please enter notices",
    subtotal: "Subtotal",
    print: "Print",
    printTitle: "Purchase Order",
    printItemNo: "No.",
    printWeight: "Weight (kg)",
    printContact: "Contact",
    printTelephone: "Telephone",
    printFax: "Fax",
    printAmountSubtotal: "Quantity Total",
    printWeightSubtotal: "Weight Total",
    printGrandTotal: "Grand Total",
    printNoticeTitle: "[Notices]",
    printFinance: "Finance",
    printApprover: "Approver",
    printApplicant: "Applicant",
    createAndSubmit: "Create and Submit for Review",
    createOrderSuccess: "Purchase order created successfully!",
    confirm: "Confirm",
    freeShipping: "Free Shipping",
    shippingFeeRequired: "Additional Shipping Fee",
    singleDelivery: "Single Delivery",
    partialDelivery: "Partial Delivery",
    yes: "Yes",
    no: "No",
    purchaseDateError: "Purchase date cannot be later than delivery date",
    productListItemsRequired: "Product list items are required",
    createFailed: "Failed to create purchase order",
    reviewApplication: "Review Application",
    applicant: "Applicant",
    applicationDate: "Application Time",
    reviewer: "Reviewer",
    reviewDate: "Review Time",
    pendingAfterSubmit: "Filled after submission",
    pendingAfterReview: "Filled after review",
    applicantPending: " (pending submission)",
    saveFailed: "Failed to save purchase order",
    rejectAction: "Reject",
    rejectReason: "Rejection Reason",
    rejectReasonRequired: "Please provide a rejection reason",
    submitReject: "Submit",
    resubmit: "Resubmit for Review",
    complete: "Complete",
    completeSuccess: "Purchase order completed",
    completeFailed: "Failed to complete purchase order",
    submitFailed: "Failed to submit purchase order for review",
    approveFailed: "Failed to approve purchase order",
    rejectFailed: "Failed to reject purchase order",
    reviewNotPassed: "Review Rejected",
    reviewPassed: "Approved",
    noApprovePermission:
      "You don't have purchase approval permission. Please contact a procurement manager.",
  },
  stockRequest: {
    title: "Stock Request Management",
    stockRequestManagement: "Stock Request Management",
    stockRequestList: "Stock Request List",
    stockRequestDoc: "Stock Request",
    editStockRequest: "Edit Stock Request",
    closeOrder: "Close Order",
    productCode: "Product Code",
    productName: "Product Name",
    noStockRequestData:
      "You haven't created any stock request data yet! You can try:",
    manualAdd: "Manual Add",
    stockRequestName: "Stock Request Name",
    requestPerson: "Request Person",
    outboundStaff: "Outbound Staff",
    createdTime: "Created Time",
    createStockRequest: "Create Stock Request",
    basicInfo: "Basic Information",
    productList: "Product List",
    addProductRow: "Add Product Row",
    productNameCode: "Product Name / Code",
    warehouseLabel: "Warehouse",
    areaLabel: "Area",
    storageLocationLabel: "Storage Location",
    quantity: "Quantity",
    delete: "Delete",
    deliveryInfo: "Delivery Information",
    deliveryPerson: "Delivery Person",
    inboundStaff: "Inbound Staff",
    remarks: "Remarks",
    cancel: "Cancel",
    create: "Create",
    submitEdit: "Submit Edit",
    stockRequestCreatedSuccess: "Stock request created successfully!",
    confirm: "Confirm",
    productListMinOne: "Product list must have at least one item",
    ensureProductComplete:
      "Please ensure all products have product, storage location and quantity selected",
    selectProductFromList:
      "Please choose a product from the dropdown; free text is not allowed",
    selectStorageFromList:
      "Please choose a storage location from the dropdown; free text is not allowed",
  },
  warehouse: {
    deleteArea: "Delete Area",
    name: "Name",
    warehouseName: "Warehouse Name",
    date: "Date",
    partner: "Partner",
    customer: "Partner (Customer)",
    remarks: "Remarks",
    address: "Address",
    warehouseAddress: "Warehouse Address",
    city: "City",
    district: "District",
    postalCode: "Postal Code",
    fullAddress: "Full Address",
    basicInfo: "Basic Information",
    contactInfo: "Contact Information",
    description: "Description",
    warehouseDescription: "Warehouse Description",
    contactPerson: "Contact Person",
    phone: "Phone",
    email: "E-mail",
    management: "Warehouse Management",
    warehouseManagement: "Warehouse and Location Management",
    storageLocationManagement: "Storage Location Management",
    list: "Warehouse List",
    add: "Add Warehouse",
    edit: "Edit Warehouse",
    view: "View Warehouse",
    delete: "Delete Warehouse",
    save: "Save",
    cancel: "Cancel",
    create: "Create",
    update: "Update",
    searchPlaceholder: "Search warehouse name or address...",
    storageLocation: "Storage Location",
    storageLocationSection: "Storage Location",
    storageLocationName: "Storage Location Name",
    capacity: "Capacity",
    currentStock: "Current Stock",
    availableSpace: "Available Space",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    actions: "Actions",
    confirmDelete: "Are you sure you want to delete this warehouse?",
    saveSuccess: "Warehouse information saved successfully",
    createSuccess: "Warehouse created successfully",
    updateSuccess: "Warehouse updated successfully",
    deleteSuccess: "Warehouse deleted successfully",
    errorFetchingData: "Error fetching warehouse data",
    errorSavingData: "Error saving warehouse data",
    errorDeletingData: "Error deleting warehouse data",
    requiredField: "This field is required",
    invalidAddress: "Please enter a valid address",
    inventoryManagement: "Inventory Management",
    stockRequestManagement: "Stock Request Management",
    inventoryCreated: "Created",
    inventoryCompleted: "Completed",
    stockRequestCreated: "Created",
    stockRequestCompleted: "Completed",
    productManagement: "Product Management",
    productName: "Product Name",
    productNameDuplicate:
      "A product with this name already exists for this partner. Please use a different name.",
    partnerLockedReferenced:
      "This product is referenced by purchase / stock-in / material requisition orders, so the partner cannot be changed.",
    filterByPartner: "Filter by Partner",
    noPartnerFound: "No matching partner",
    productCode: "Product Code",
    productDescription: "Product Description",
    productImage: "Product Image",
    uploadImage: "Click to upload image",
    imageUploading: "Uploading image...",
    imageUploadError: "Image upload failed",
    productType: "Product Type",
    selectItem: "Select Item",
    selectCategory: "Select Category",
    selectSteelType: "Select Steel Type",
    autoCalculated: "Auto-calculated",
    itemSource: "Item Source",
    companyItem: "Company Item",
    defaultItem: "Default Item",
    itemCategory: "Item Category",
    steelItemType: "Steel Type",
    screwItemType: "Screw Type",
    generalType: "General",
    steelType: "Steel",
    steelCategory: "Type",
    sectionDimension: "Section Dimension",
    material: "Material",
    length: "Length",
    unitQuantity: "Unit Quantity",
    unitWeight: "Unit Weight (kg/m)",
    weight: "Weight",
    specifications: "Specifications",
    unit: "Unit",
    quantity: "Quantity",
    storageSpot: "Storage Spot",
    amount: "Amount",
    inventoryLowerLimit: "Set Inventory Lower Limit",
    inventoryLowerLimitContact: "Inventory Lower Limit Contact",
    addProductRow: "Add Product Row",
    createProduct: "Create Product",
    editProduct: "Edit Product",
    productCreateSuccess: "Warehouse created successfully!",
    unitPrice: "Unit Price",
    totalAmount: "Total Amount",
    supplier: "Supplier",
    deliveryPerson: "Delivery Person",
    licensePlateNumber: "Delivery License Plate",
    warehouseStaff: "Warehouse Staff",
    inboundStaff: "Inbound Staff",
    outboundStaff: "Outbound Staff",
    shippingLocation: "Shipping Location",
    deliveryDate: "Delivery Date",
    receivedDate: "Received Date",
    requestDate: "Request Date",
    completedDate: "Completed Date",
    enable: "Enable",
    enabledValue: "Yes",
    disabledValue: "No",
    warehouseDescriptionLabel: "Warehouse Description",
    storageLocationSection: "Warehouse Storage Location",
    addStorage: "Add Storage Location",
    editBtn: "Edit",
    deleteBtn: "Delete",
    noEmployeeData: "No employee data available for selection",
    selectContact: "Please select contact",
    createWarehouse: "Add Warehouse",
    confirm: "Confirm",
    fieldDescription: "Field Description",
    warehouseCreatedSuccess: "Warehouse created successfully!",
    stockReceiptName: "Stock Receipt Name",
    createStockReceipt: "Create Stock Receipt",
    stockReceiptManagement: "Stock Receipt Management",
    stockReceiptList: "Stock Receipt List",
    editStockReceipt: "Edit Stock Receipt",
    noStockReceiptData:
      "You haven't created any stock receipts yet! You can try:",
    noStockReceiptDoneData: "No completed stock receipts yet.",
    stockReceiptDoneManagement: "Inventory Summary",
    stockReceiptDoneList: "Completed Stock Receipt List",
    createdTime: "Created Time",
    closeOrder: "Close Order",
    productList: "Product List",
    productNameCode: "Product Name / Code",
    warehouseLabel: "Warehouse",
    areaLabel: "Area",
    storageLocationLabel: "Storage Location",
    deliveryInfo: "Delivery Information",
    stockReceiptCreatedSuccess: "Stock receipt created successfully!",
    productListMinOne: "Product list must have at least one item",
    ensureProductComplete:
      "Please ensure each product has product, storage location and quantity selected",
    selectProductFromList:
      "Please choose a product from the dropdown; free text is not allowed",
    selectStorageFromList:
      "Please choose a storage location from the dropdown; free text is not allowed",
    warehouseArea: "Warehouse Area",
    areaSection: "Warehouse Areas",
    areaName: "Area Name",
    addArea: "Add Area",
    editArea: "Edit Area",
    areaDescription: "Area Description",
    noAreaYet: "No warehouse areas yet",
    deleteAreaConfirm:
      "Delete this area? Its storage locations will also be removed.",
    picture: "Picture",
    pictureUrlPlaceholder: "Image URL",
    storageLocationCount: "Storage Locations",
    selectWarehouse: "Select Warehouse",
    selectWarehousePrompt: "Select a warehouse to edit its layout",
    saveLayout: "Save Layout",
    saving: "Saving…",
    layoutSaved: "Layout saved",
    layoutSaveError: "Failed to save layout",
    loadLayoutError: "Failed to load warehouse layout",
    itemSaveError: "Failed to save item",
    itemDeleteError: "Failed to delete item",
    renameError: "Failed to rename",
    openManagementSystem: "Open Management System",
  },
  stockHistory: {
    title: "Stock Movement History",
    subtitle:
      "Click a product to see the date and quantity of every receipt and request",
    totalItems: "Products",
    totalIn: "Total In",
    totalOut: "Total Out",
    goodsList: "Product List",
    searchPlaceholder: "Search product name",
    perPage: "Per page",
    pageLabel: "Page",
    prevPage: "Previous",
    nextPage: "Next",
    colProduct: "Product",
    colLocation: "Warehouse / Location",
    colIn: "In",
    colOut: "Out",
    colStock: "Current Stock",
    locationUnit: "locations",
    stockLabel: "Stock",
    statusOut: "Out of Stock",
    statusLow: "Low Stock",
    statusNormal: "Normal",
    loading: "Loading…",
    noResult: "No matching products",
    drawerLabel: "Product movement history",
    close: "Close",
    stockDistribution: "Stock Distribution",
    locationCount: "locations",
    locationColumn: "Warehouse / Area / Location",
    noLocation: "No storage location data",
    allLocations: "All Locations",
    noMovement: "No movement records yet",
    noMovementForLocation: "No movement records for this location",
    docTypeIn: "Stock Receipt",
    docTypeOut: "Material Request",
    deliveryPerson: "Delivery Staff",
    pickupPerson: "Picked Up By",
    warehouseLabel: "Warehouse",
    areaSuffix: "Area",
  },
  pdfPreview: {
    title: "Drawing Preview",
    openInNewTab: "Open in New Tab",
    close: "Close",
    notFound: "No matching PDF drawing found",
  },
  ifcViewer: {
    title: "3D Model Preview",
    close: "Close",
    pickFile: "Choose a local .ifc file",
    notFound: "This project has no IFC analysis result yet",
    loading: "Loading 3D model…",
    analyzing: "Analysing the local IFC…",
    empty: "This IFC file has no displayable geometry",
    noMatch: "This IFC file has no matching assembly",
    sharedMark:
      "{{count}} pieces share this assembly mark — showing one of them",
    error: "Failed to load the 3D model",
    resetView: "Reset view",
  },
  rfq: {
    addLine: {
      title: "Add RFQ lines",
      description: "Lines are always picked from existing products; name and spec come from the product.",
      search: "Search name / spec / material",
      noProduct: "No products found.",
      selected: "{{n}} selected",
      empty: "Pick products on the left, then set quantity and due date here.",
      remove: "Remove",
      cancel: "Cancel",
      confirm: "Add {{n}}",
    },
    list: {
      create: "New RFQ",
      search: "Search code / title / buyer",
      allStatus: "All statuses",
      empty: "No RFQs yet. Click New RFQ to start.",
      colCode: "RFQ no.",
      colName: "Project name",
      colIssueDate: "Issue date",
      colDeliveryLocation: "Delivery location",
      colApplicant: "Buyer",
      colStatus: "Status",
      cancel: "Cancel",
      confirmCreate: "Create",
    },
    unsupportedField: "The backend does not provide this field yet, so it cannot be saved",
    loadFailed: "Failed to load RFQ",
    actionFailed: "Action failed",
    createFailed: "Failed to create RFQ",
    notFound: "RFQ not found",
    backToList: "Back to RFQ list",
    statusNoticeInquiring: "Inquiring — header, lines, vendors and awards are editable",
    statusNoticeLocked: "Not inquiring — header, lines and awards are read-only",
    voidDisabled: "The backend has no void status, not supported yet",
    reviewHint: "Approve or reject in the Vendors & Pricing tab",
    title: "RFQ",
    roleManager: "Purchasing manager view",
    roleBuyer: "Buyer view",
    statusNotice: "Comparing — the header is read-only; lines and awards can still be edited",
    saveDraft: "Save draft",
    saveDraftDisabled: "The header is read-only while comparing",
    void: "Void",
    tabDetail: "Lines",
    tabPricing: "Vendors & comparison",
    tabHistory: "History",
    status: {
      draft: "Draft",
      inquiring: "Inquiring",
      comparing: "Comparing",
      pendingReview: "Pending manager review",
      awarded: "Awarded",
      voided: "Voided",
    },
    category: {
      material: "Material",
      fabrication: "Shop fabrication",
      surface: "Surface treatment",
      bolt: "Bolts / couplers",
      transport: "Transport / lifting",
      other: "Other",
    },
    priceMode: {
      weight: "By weight (NT$/kg)",
      unit: "By unit",
    },
    reply: {
      pending: "No reply",
      quoted: "Quoted",
      declined: "Declined",
      overdue: "Overdue",
    },
    attachKind: {
      drawing: "Drawing",
      spec: "Specification",
      material: "Material requirement",
      other: "Other",
    },
    awardReason: {
      dueDate: "Lead time cannot be met",
      quality: "Poor quality record",
      capacity: "Insufficient capacity",
      noMtc: "Cannot provide MTC",
      altMaterial: "Material substitution required",
      payment: "Payment terms mismatch",
      other: "Other",
    },
    info: {
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      remark: "Remark",
      reviewer: "Reviewer",
      reviewDate: "Review date",
      requireDateHint: "Required delivery date is set per line, adjust it in the lines tab",
      sectionTitle: "RFQ information",
      collapse: "Collapse",
      expand: "Expand",
      no: "RFQ No.",
      title: "RFQ title",
      project: "Project",
      contract: "Contract No.",
      issueDate: "Issue date",
      deadline: "Quote deadline",
      deliverTo: "Delivery location",
      requireDate: "Required date",
      paymentTerms: "Our payment terms",
      priceBasis: "Price basis",
      priceBasisDap: "Delivered to site (DAP)",
      priceBasisExw: "Ex works (EXW)",
      budget: "Budget total (sum of target prices)",
      buyer: "Buyer in charge",
      categories: "Included categories",
      sourcePo: "Source purchase orders",
      attachments: "Attachments (drawings / specs / material requirements)",
      addAttachment: "Add attachment",
      noAttachment: "No attachments yet — use Add attachment to upload drawings, specs or material requirements.",
      download: "Download",
      remove: "Remove",
    },
    detail: {
      categoryFieldsDisabled: "The backend has no category detail fields, editing is disabled",
      footerServer: "{{total}} lines. Name, spec and unit come from the product and are read-only; quantity and due date are editable.",
      sectionTitle: "RFQ lines",
      empty: "No lines yet — import items from a purchase order first.",
      importFromPo: "Import from purchase order",
      viewSeq: "By line no.",
      viewGroup: "Group by spec",
      deleteSelected: "Delete selected",
      addManual: "Add manually",
      colSeq: "No.",
      colName: "Item",
      colCategory: "Category",
      colSpec: "Spec",
      colQty: "RFQ qty",
      colUnit: "Unit",
      colPriceMode: "Compare mode",
      colCategoryFields: "Category fields",
      colWeight: "Total weight (kg)",
      colDueDate: "Required date",
      colMtc: "MTC",
      colTargetPrice: "Target price",
      colNote: "Note",
      autoWeight: "Auto-calculated",
      noWeight: "Spec missing — cannot calculate",
      unitPriced: "— (priced by unit)",
      sourceQty: "Source {{qty}}",
      sourceMark: "From {{po}} · line {{seq}}",
      manualMark: "Added manually",
      newItem: "New item",
      noExtraField: "No extra fields for this category",
      unitWeightHint: "Unit weight {{value}} kg/m",
      groupSummary: " · {{n}} items · qty {{qty}} · {{weight}} kg",
      footer: "{{total}} lines · {{po}} imported · {{manual}} manual. Specs imported from a purchase order are read-only; quantities stay editable.",
      fieldMaterial: "Material",
      fieldSectionType: "Section type",
      fieldNominalSpec: "Nominal spec",
      fieldLength: "Length (mm)",
      fieldCount: "Pieces",
      fieldMemberType: "Member type",
      fieldWeldGrade: "Weld grade",
      fieldNeedUt: "UT required",
      fieldUtRatio: "UT %",
      fieldTreatment: "Treatment",
      fieldBoltGrade: "Grade",
      fieldBoltSize: "Size",
      fieldOrigin: "Origin",
      fieldDestination: "Destination",
      fieldTruckType: "Truck type",
    },
    importModal: {
      loading: "Loading…",
      noOrder: "No purchase orders found.",
      noLine: "This purchase order has no product lines.",
      title: "Import lines from purchase orders",
      description: "Pick items across several purchase orders; imported specs are read-only and quantities stay editable.",
      search: "Search order no. / project",
      lineCount: "{{n}} lines",
      linesOf: "{{po}} lines",
      selectAll: "Select all",
      deselectAll: "Clear all",
      colSeq: "No.",
      colNameSpec: "Item / spec",
      colMaterial: "Material",
      colPoQty: "PO qty",
      colRfqQty: "RFQ qty",
      basket: "Selected",
      basketCount: "{{orders}} orders · {{lines}} lines",
      basketEmpty: "Items you tick in the middle column are collected here.",
      removePick: "Remove",
      cancel: "Cancel",
      importCount: "Import {{n}} lines",
    },
    vendor: {
      search: "Search vendor name / tax ID",
      noPartner: "No partners found.",
      alreadyInvited: "Added",
      cancel: "Cancel",
      addConfirm: "Add {{n}}",
      markDeclined: "Mark declined",
      remove: "Remove",
      empty: "No vendors yet. Click Add vendor to pick from partners.",
      sectionTitle: "Invited vendors",
      addVendor: "Add vendor",
      sent: "Sent",
      received: "Quoted",
      declined: "Declined",
      pending: "No reply",
      colName: "Vendor",
      colTaxId: "Tax ID",
      colContact: "Contact",
      colPhone: "Phone",
      colReply: "Reply status",
      colAction: "Actions",
      recordQuote: "Record quote",
      recordNegotiation: "Record negotiation",
      fallbackName: "Vendor",
    },
    record: {
      deliveryDate: "Promised delivery",
      taxIncluded: "Tax included",
      remark: "Remark",
      quoteUnitLocked: "The backend prices by the RFQ unit, so the quote unit follows the line",
      title: "Record quote — {{vendor}}",
      descriptionNew: "Quotes received by phone, email or fax, entered by the buyer.",
      descriptionReQuote: "The vendor replied to the negotiation — enter the new price; the previous quote is kept and the change is calculated.",
      supplied: "Can supply",
      unitPrice: "Quoted unit price",
      quoteUnit: "Quote unit",
      freightIncluded: "Freight to site included",
      requirement: "Required",
      cancel: "Cancel",
      save: "Save quote",
    },
    pricing: {
      freightDapDisabled: "The backend has no vendor freight total, apportionment is not supported",
      taxBasis: "Tax basis",
      taxExcl: "Excl. tax",
      taxIncl: "Incl. tax",
      freightBasis: "Freight basis",
      freightExw: "Ex works",
      freightDap: "Delivered to site",
      autoAward: "Fill in lowest prices",
      legendBest: "Lowest price",
      legendClose: "Within 3%",
      legendOver: "Above target price",
      legendNegotiated: "Negotiated reduction",
      legendMissing: "Missing / not quoted",
      legendFormula: "Hover a price to see the conversion",
      legendExpand: "Click a line to expand quotes and negotiation history",
      negotiatedTag: "Negotiated",
      tableTitle: "Comparison",
      colLine: "Line / item & spec",
      colBase: "Basis",
      colTarget: "Target price",
      missing: "Missing",
      cannotCompare: "Not comparable",
      vsBest: "+{{pct}}% vs lowest",
      vsTarget: "{{pct}}% vs target",
      negotiatedFrom: "Before negotiation {{from}}/{{fromUnit}} → now {{to}}/{{toUnit}}",
      vendorTotal: "Adjusted vendor total ({{tax}} · {{freight}})",
      detailTitle: "Quotes and negotiation history",
      noQuote: "No vendor has quoted this line yet.",
      best: "Lowest",
      quote: "Quote",
      converted: "Converted basis",
      subtotal: "Subtotal",
      freight: "Freight",
      freightIncluded: "Delivered to site",
      freightExcluded: "Ex works (freight extra)",
      alternative: "Alternative",
      altApproved: "approved",
      altPending: "pending approval",
      negotiation: "Negotiation",
      firstQuote: "First quote, not negotiated",
    },
    award: {
      skipReasonDisabled: "The backend has no skip-reason field, so it cannot be saved",
      reviewNotice: "This RFQ is under review; approve or reject it.",
      rejectReason: "Reject reason",
      reject: "Reject",
      approve: "Approve",
      sectionTitle: "Award",
      decided: "{{decided}}/{{total}} decided",
      buyerNotice: "Awarding is done by the purchasing manager; buyers can only view the comparison.",
      selectVendor: "Select winning vendor",
      skipReason: "Reason for skipping",
      skip: "Skip this time",
      resume: "Resume",
      total: "Award total (excl. tax)",
      targetTotal: "Target amount",
      diff: "Difference vs target",
      save: "Save award",
      submit: "Submit for review",
    },
    history: {
      action: {
        created: "RFQ created",
        proxyQuoteRecorded: "Quote recorded",
        vendorDeclined: "Vendor declined",
        proxyNegotiationRecorded: "Negotiation recorded",
        submittedForReview: "Submitted for review",
        approved: "Approved",
        rejected: "Rejected",
      },
      empty: "No history yet.",
      system: "System",
      detailRejected: "Reject reason: {{reason}}",
      detailNegotiation: "{{item}} unit price {{from}} → {{to}}",
      detailQuote: "{{item}} unit price {{price}}",
      sectionTitle: "History",
      actor: "By",
      recordedDetail: "Recorded {{n}} quoted lines",
    },
    calc: {
      manualInput: "Manual entry",
      manualOverride: "Manual override",
      quote: "Quote",
      lineWeight: "Line weight",
      freightShare: "Freight share",
      compareBase: "Comparison basis",
      noWeight: "No total weight — cannot convert",
      perUnit: "NT$/{{unit}}",
      pieces: "pcs",
      unitMismatch: "Quote unit {{quoteUnit}} differs from RFQ unit {{lineUnit}} — cannot convert automatically",
      taxUplift: "Incl. tax ×1.05",
      freightIncluded: "incl. freight",
      freightApportioned: "freight apportioned",
    },
    export: {
      print: "Print",
      title: "RFQ",
      projectAddress: "Project address",
      projectName: "Project name",
      code: "RFQ no.",
      printedAt: "Printed",
      item: "Item",
      vendor: "Vendor",
      spec: "Spec",
      quotePrice: "Quoted price",
      quoteDate: "Quote date",
      negotiatedPrice: "Negotiated price",
      negotiatedDate: "Negotiation date",
      purchasePrice: "Purchase price",
      purchaseDate: "Purchase date",
      remark: "Remark",
      declined: "Declined",
      notPurchased: "Not purchased",
      purchaseTitle: "Purchase order",
      contractQty: "Contract qty",
      costPrice: "Cost price",
      customerPrice: "Customer price",
      handler: "Handler",
      manager: "Manager",
      vicePresident: "VP",
    },
  },
  warehouseMap: {
    zoneLabel: "{{name}} Area",
    newSlot: "New slot",
    itemCount_one: "{{count}} item",
    itemCount_other: "{{count}} items",
    slotCount_one: "{{count}} slot",
    slotCount_other: "{{count}} slots",
    cancel: "Cancel",
    confirm: "Confirm",
    instructions: "Instructions",
    page: {
      title: "Warehouse Management System",
      selected: "Selected:",
      pressDeleteHint: "(Press Delete to remove)",
    },
    floorPlanUpload: {
      title: "Upload warehouse floor plan",
      hint: "Click to upload an image, or drag to draw areas directly",
    },
    rename: {
      nameRequired: "Please enter a name",
      chooseIcon: "Choose an icon (optional)",
      searchIcon: "Search icons",
      noIcon: "No icon",
      noIconFound: "No matching icons",
      iconHint: "You can add an icon (optional) before the name. Preview: ",
    },
    slotTemplate: {
      clickToRenameZone: "Click to rename area",
      subtitle: "Drag a slot into the area to create a storage location",
      templates: "Slot template",
      dragIntoZone: "Drag into area",
      slotsInZone: "Storage locations ({{count}})",
      noSlots: "No storage locations yet. Drag the template above into the area to create one.",
      instrDragTemplate: "Drag the slot template above onto the area on the canvas",
      instrClickSlot: "Click a slot to select it and view its contents",
      instrResize: "Once selected, drag the handles to resize",
      instrDelete: "Press Delete to remove the selected slot",
      homeTip: "Tip: click the Home button at the top left to return to the warehouse overview",
      renameZoneTitle: "Rename area",
      zoneNameLabel: "Area name",
    },
    slotDetail: {
      selectProductRequired: "Please select a product",
      duplicateProduct: "This slot already contains this product",
      invalidQuantity: "Please enter a valid quantity",
      invalidLimit: "Please enter a valid limit",
      addItem: "Add product",
      editItem: "Edit product",
      product: "Product",
      selectProduct: "Select product",
      productNotFound: "No products found",
      quantity: "Quantity",
      limit: "Limit",
      confirmAdd: "Add",
      saveChanges: "Save changes",
      deleteItem: "Delete product",
      confirmDeleteItem: "Delete product \"<b>{{name}}</b>\"? This cannot be undone.",
      confirmDelete: "Delete",
      emptyState: "Select a storage location to view its contents",
      clickToRenameSlot: "Click to rename storage location",
      slotTitle: "Slot {{name}}",
      productCount_one: "{{count}} product",
      productCount_other: "{{count}} products",
      saveLayoutFirst: "Save the layout before managing products in this slot",
      productName: "Product name",
      renameSlotTitle: "Rename storage location",
      slotNameLabel: "Storage location name",
    },
    toolbar: {
      removeFloorPlan: "Remove floor plan",
      removeFloorPlanConfirm: "Remove the current floor plan background? This cannot be undone.",
      remove: "Remove",
      replaceFloorPlan: "Replace floor plan",
      uploadFloorPlan: "Upload floor plan",
      floorPlanOverviewOnly: "Floor plan (warehouse overview only)",
      editFloorPlan: "Edit floor plan (drag to move / corners to resize)",
      editFloorPlanOverviewOnly: "Edit floor plan tool (warehouse overview only)",
      removeFloorPlanOverviewOnly: "Remove floor plan (warehouse overview only)",
      selectTool: "Select / move (drag to pan)",
      selectToolOverviewOnly: "Select tool (warehouse overview only)",
      drawZone: "Draw area (drag to create)",
      drawZoneOverviewOnly: "Draw area tool (warehouse overview only)",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
      backToOverview: "Back to warehouse overview",
      collapseInstructions: "Collapse instructions",
      expandInstructions: "Expand instructions",
      instrSelectTool: "Select tool: drag to pan, tap to select, double-tap to enter",
      instrDrawTool: "Draw tool: drag to create an area",
      instrFloorPlanTool: "Floor plan tool: drag to move, corners to resize",
      instrDragSlot: "Drag from the right panel to create a slot",
      instrClickSlot: "Tap a slot to view its contents",
      instrClickZone: "Tap empty space in an area to select it",
      instrMoveResize: "After selecting, drag to move or resize",
      instrZoom: "Scroll / pinch to zoom, or + − keys",
      instrPan: "Two-finger swipe / Alt+drag to pan",
    },
  },
  itemEditor: {
    notify: {
      loadFailed: "Failed to load items",
      created: "Item created",
      createFailed: "Failed to create item",
      saved: "Item saved",
      saveFailed: "Failed to save item",
      copied: "Copied as a new item",
      copyFailed: "Failed to copy item",
    },
    panel: {
      title: "Edit Item",
      presetData: "Preset",
      emptyTitle: "Select an item",
      emptyHint: "Pick an item from the list to edit it, or click \"Add Item\" to create one",
    },
    field: {
      category: "Category",
      steelType: "Section Type",
      screwType: "Fastener Type",
      sectionSpec: "Section Size",
      name: "Item Name",
      namePlaceholder: "Enter item name",
      description: "Description",
      descriptionPlaceholder: "Enter item description...",
    },
    weight: {
      title: "Unit Weight",
      area: "Section area: ",
      unitWeight: "Unit weight: ",
    },
    action: {
      cancel: "Cancel",
      close: "Close",
      copyAndEdit: "Copy & Edit",
      save: "Save Item",
    },
    addDialog: {
      title: "Add Item",
      submit: "Create Item",
      selectCategory: "Select category",
      selectSteelType: "Select section type",
      selectScrewType: "Select fastener type",
      specPreview: "Size: {{spec}}",
    },
    grid: {
      searchPlaceholder: "Search item name / size",
      filter: "Filter",
      addItem: "Add Item",
      preset: "Preset",
      total: "{{total}} items",
      perPage: "{{size}} / page",
    },
    sidebar: {
      noData: "No data",
    },
    category: {
      all: "All Items",
      steel: "Steel Sections",
      screw: "Fasteners",
      parts: "Steel Parts",
      consumables: "Steel Consumables",
      hardware: "Hardware",
      uncategorized: "Uncategorized",
    },
    steelType: {
      TUBE: "Square tube",
      BOX: "Box section",
      H: "H-beam",
      RH: "Rolled H-beam",
      BH: "Built-up H-beam",
      I: "I-beam",
      L: "Angle",
      U: "Channel",
      BT: "BT section",
      CT: "CT section",
      T: "T section",
      C: "C channel",
      PIPE: "Pipe",
      FB: "Flat bar",
      RB: "Round bar",
    },
    screwType: {
      hexBolt: "Hex bolt",
      hexNut: "Hex nut",
      washer: "Washer",
      highStrengthBoltSet: "High-strength bolt set",
      anchorBolt: "Anchor bolt",
      shearStud: "Shear stud",
    },
    specField: {
      width: "W",
      height: "H",
      thickness: "t",
      flangeThickness: "Flange t",
      webThickness: "Web t",
      legA: "Leg A",
      legB: "Leg B",
      lip: "Lip",
      outerDiameter: "OD",
      diameter: "Dia.",
    },
  },
  companyCalendar: {
    title: "Calendar",
    description: "Shared company calendar — categorize and filter events by employee tag",
    monthView: "Month",
    filterPlaceholder: "Filter by employee tag (empty shows all)",
    clickHint: "Click a date to add an event; click an event to edit or delete it",
    subscribe: "Subscribe",
    subscribeTitle: "Subscribe to Calendar",
    subscribeHint: "Scan the QR code with your phone camera or calendar app to subscribe",
    subscribeUnavailable: "Could not get the subscription link, please try again later",
    subscribeScope: "Scope:",
    copyLink: "Copy Link",
    copied: "Link copied",
    copyFailed: "Copy failed",
    close: "Close",
    loading: "Loading…",
    addEvent: "Add Event",
    editEvent: "Edit Event",
    eventTitle: "Title",
    eventTitlePlaceholder: "e.g. Monthly meeting, fire drill",
    titleRequired: "Please enter a title",
    dateRequired: "Please select a date",
    allDay: "All day",
    visibleTags: "Employee tags",
    visibleTagsHint: "Tags categorize and filter events; leave empty for an all-staff event",
    allEmployees: "All employees",
    unknownTag: "(Deleted tag)",
    currentlyVisibleTo: "Tags:",
    location: "Location",
    eventDescription: "Description",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    deleteConfirm: "Delete this event?",
    createSuccess: "Event added",
    updateSuccess: "Event updated",
    saveFailed: "Save failed",
    deleteSuccess: "Event deleted",
    deleteFailed: "Delete failed",
    moreEvents: "+{{count}} more",
    dateRange: "Dates (can span multiple days)",
    dateTimeRange: "Start ~ End",
    dateRangeHint: "Pick a start and end date; multi-day events appear on every day they cover",
    loadFailed: "Failed to load calendar",
    isCompleted: "Completed",
    createdBy: "Created by: ",
    updatedBy: "Last modified: ",
    auditInfo: "Change history",
    subscribeGoogle: "Add to Google Calendar",
    subscribeApple: "Add to Apple Calendar",
    color: "Color",
    colorHint: "When not set, the color follows the event's first employee tag",
    colorAuto: "Auto (by tag)",
    colorCustom: "Custom",
    endBeforeStart: "End must be after start",
    prevMonth: "Previous month",
    nextMonth: "Next month",
    today: "Today",
  },
  warRoom: {
    common: {
      none: "(None)",
      notFilled: "(Not filled)",
      unnamed: "(Unnamed)",
      uncategorized: "(Uncategorized)",
      noData: "(No data)",
      other: "Other",
      count: "Count",
    },
    groups: {
      basic: "Basic info",
      partner: "Partners",
      project: "Project management",
      purchase: "Purchasing",
      product: "Products",
      warehouse: "Warehouse",
      finance: "Finance",
    },
    datasets: {
      employee: {
        label: "Employees",
        description: "All employees in the company — headcount distribution and driver's license rates.",
        fields: {
          name: "Name",
          status: "Status",
          gender: "Gender",
          bloodType: "Blood type",
          birthday: "Birthday",
          motorbikeLicense: "Motorcycle license",
          carLicense: "Car license",
          isProjectReport: "Project reporter",
        },
      },
      partner: {
        label: "Partners",
        description: "All partners (customers/suppliers) — status and invoice type distribution.",
        fields: {
          name: "Name",
          status: "Deactivation status",
          invoiceType: "Invoice type",
          business: "Business scope",
          applicationDate: "Application date",
        },
      },
      project: {
        label: "Projects",
        description: "Project list with partner and node count — projects opened per month, closure ratio.",
        fields: {
          name: "Project name",
          status: "Project status",
          partnerName: "Partner",
          date: "Start date",
          nodeCount: "Node count",
        },
      },
      projectNode: {
        label: "Project nodes (member stats)",
        description: "Project nodes with member fabrication stats (pending / in progress / completed) — good for tracking each project's fabrication progress.",
        fields: {
          name: "Node name",
          nodeType: "Node type",
          projectName: "Project",
          pending: "Pending members",
          inProgress: "In-progress members",
          completed: "Completed members",
          totalAssemblies: "Total members",
          completedRatio: "Completion %",
        },
      },
      workItem: {
        label: "Work items (with completion)",
        description: "All work items and whether they are complete. The workItem API returns no relations, so the project name is joined on the frontend via projectNodeId → projectNode → project.",
        fields: {
          name: "Work item name",
          projectName: "Project",
          nodeName: "Node",
          isCompleted: "Completed",
          scanMode: "Scan mode",
          plannedCompletionDate: "Planned completion date",
          completedCount: "Completed count",
        },
      },
      purchaseOrder: {
        label: "Purchase orders",
        description: "Purchase orders with line totals (sum of quantity × unit price from purchaseOrderProduct) — purchase amount by status and by partner.",
        fields: {
          name: "Purchase order name",
          status: "Order status",
          partnerName: "Partner",
          purchaseDate: "Purchase date",
          deliveryDate: "Delivery date",
          applicationDate: "Application date",
          deliveryMethod: "Delivery method",
          shippingFeeCalculation: "Shipping fee",
          orderAmount: "Purchase amount",
          actualShippingFee: "Actual shipping fee",
          lineCount: "Line items",
          totalQuantity: "Total quantity",
          requiresInvoice: "Invoice required",
        },
      },
      purchaseOrderProduct: {
        label: "Purchase order lines",
        description: "Individual purchase lines — purchase quantity and amount per product.",
        fields: {
          productName: "Product",
          orderName: "Purchase order",
          orderStatus: "Order status",
          partnerName: "Partner",
          amount: "Quantity",
          unitPrice: "Unit price",
          lineTotal: "Subtotal",
        },
      },
      product: {
        label: "Products",
        description: "Product master data — material distribution, unit weight vs. length (scatter).",
        fields: {
          name: "Product name",
          partnerName: "Supplier",
          itemName: "Item",
          mainCategory: "Main category",
          subCategory: "Subcategory",
          material: "Material",
          unit: "Unit",
          length: "Length",
          unitWeight: "Unit weight",
          inventoryLowerLimit: "Min. stock",
        },
      },
      item: {
        label: "Items",
        description: "Item master data — item count by main category / subcategory.",
        fields: {
          name: "Item name",
          mainCategory: "Main category",
          subCategory: "Subcategory",
        },
      },
      productInventory: {
        label: "Product inventory",
        description: "Stock levels and limits per storage location — top stock, fill level.",
        fields: {
          productName: "Product",
          storageLocationName: "Storage location",
          material: "Material",
          amount: "Stock quantity",
          inventoryUpperLimit: "Max. stock",
          utilization: "Fill level %",
        },
      },
      warehouse: {
        label: "Warehouses",
        description: "Warehouse master data and enabled status.",
        fields: {
          name: "Warehouse name",
          enable: "Enabled",
        },
      },
      storageLocation: {
        label: "Storage locations",
        description: "Storage location master data and enabled status.",
        fields: {
          name: "Storage location name",
          enable: "Enabled",
        },
      },
      stockReceipt: {
        label: "Stock receipts",
        description: "Stock receipts with creation time — receipts per month.",
        fields: {
          name: "Document name",
          status: "Status",
          deliveryPerson: "Delivered by",
          createdAt: "Created date",
        },
      },
      stockRequest: {
        label: "Stock requisitions",
        description: "Material requisitions with creation time — requisitions per month.",
        fields: {
          name: "Document name",
          status: "Status",
          deliveryPerson: "Delivered by",
          createdAt: "Created date",
        },
      },
      financeArAp: {
        label: "Receivable vs. payable",
        description: "Receivables and payables merged into one dataset — use \"Type\" as the series to compare them directly. Note: the payables table has no date column; the date is the earliest invoice date among its details.",
        fields: {
          kind: "Type",
          name: "Document name",
          partnerName: "Partner",
          date: "Date (AR = billing date / AP = invoice date)",
          requestedAmount: "Billed amount (excl. tax)",
          amountWithTax: "Billed amount (incl. tax)",
          taxRate: "Tax rate %",
          paidAmount: "Amount paid",
          outstandingAmount: "Outstanding balance",
          detailCount: "Detail count",
          isFullySettled: "Fully settled",
        },
      },
      accountsReceivable: {
        label: "Accounts receivable",
        description: "Accounts receivable with partner and summed receipt details. Date = billing date.",
        fields: {
          name: "Document name",
          partnerName: "Partner",
          date: "Billing date",
          requestedAmount: "Billed amount (excl. tax)",
          amountWithTax: "Billed amount (incl. tax)",
          taxRate: "Tax rate %",
          paidAmount: "Amount paid",
          outstandingAmount: "Outstanding balance",
          detailCount: "Detail count",
          isFullySettled: "Fully settled",
        },
      },
      accountsPayable: {
        label: "Accounts payable",
        description: "Accounts payable. The backend schema has no date column, so the date is the earliest invoice date among its details; for an accurate timeline use \"Receivable / payable details\".",
        fields: {
          name: "Document name",
          partnerName: "Partner",
          date: "Date (earliest invoice date in details)",
          requestedAmount: "Billed amount (excl. tax)",
          amountWithTax: "Billed amount (incl. tax)",
          taxRate: "Tax rate %",
          paidAmount: "Amount paid",
          outstandingAmount: "Outstanding balance",
          detailCount: "Detail count",
          isFullySettled: "Fully settled",
        },
      },
      accountsDetail: {
        label: "Receivable / payable details (with payment dates)",
        description: "Individual receipt/payment details; both sides have paymentDate / invoiceDate — the most accurate source for a finance timeline.",
        fields: {
          kind: "Type",
          bankName: "Bank",
          paymentMethod: "Payment method",
          paymentDate: "Payment date",
          invoiceDate: "Invoice date",
          checkClearanceDate: "Check clearance date",
          amount: "Payment amount",
          handlingFee: "Handling fee",
          retentionAmount: "Retention",
          deductionAmount: "Deduction",
          netAmount: "Net amount",
          isSettled: "Settled",
        },
      },
      bank: {
        label: "Bank accounts",
        description: "Bank account balances.",
        fields: {
          name: "Bank name",
          balance: "Balance",
        },
      },
    },
    enums: {
      projectStatus: {
        normal: "Active",
        close: "Closed",
      },
      purchaseOrderStatus: {
        draft: "Draft",
        underReview: "Under review",
        approved: "Approved",
        rejected: "Rejected",
        completed: "Completed",
      },
      paymentMethod: {
        check: "Check",
        transfer: "Bank transfer",
        cash: "Cash",
        credit: "Credit card",
      },
      deliveryMethod: {
        single: "Single shipment",
        partial: "Partial shipments",
      },
      shippingFeeCalculation: {
        freeShipping: "Free shipping",
        shippingFeeRequired: "Shipping fee required",
      },
      nodeType: {
        building: "Building",
        zone: "Zone",
        batch: "Batch",
        package: "Member package",
      },
      scanMode: {
        multiple: "Multiple",
        single: "Single",
        all: "All",
      },
      employeeStatus: {
        normal: "Active",
        resigned: "Resigned",
      },
      partnerStatus: {
        normal: "Active",
        underReview: "Under review",
        disabled: "Disabled",
      },
      stockDocStatus: {
        normal: "Open",
        done: "Closed",
      },
      accountKind: {
        AR: "Receivable",
        AP: "Payable",
      },
      bool: {
        true: "Yes",
        false: "No",
      },
    },
    chartForms: {
      line: {
        label: "Line chart",
        job: "Trend over time",
      },
      area: {
        label: "Area chart",
        job: "Trend of a single series over time",
      },
      column: {
        label: "Column chart",
        job: "Compare values (few categories, short names)",
      },
      bar: {
        label: "Bar chart",
        job: "Compare values (many categories, long names)",
      },
      groupedColumn: {
        label: "Grouped column chart",
        job: "Compare several series within each category",
      },
      stackedColumn: {
        label: "Stacked column chart",
        job: "Composition (part-to-whole)",
      },
      stackedBar: {
        label: "Stacked bar chart",
        job: "Composition (many categories or long names)",
      },
      pie: {
        label: "Pie chart",
        job: "Proportions at a glance (only for ≤ 6 slices)",
      },
      scatter: {
        label: "Scatter plot",
        job: "Relationship between two measures",
      },
      heatmap: {
        label: "Heatmap",
        job: "Measure across two crossed dimensions",
      },
    },
    aggregation: {
      count: "Count",
      sum: "Sum",
      avg: "Average",
      min: "Min",
      max: "Max",
      countDistinct: "Distinct count",
    },
    aggregate: {
      valueLabel: "{{agg}} ({{field}})",
      warnings: {
        scatterSeriesFolded: "In a scatter plot any two colors may sit next to each other, so the safe limit is {{cap}} series; the remaining {{folded}} were folded into \"{{other}}\" (gray). To compare them one by one, use facets or a grouped column chart.",
        emptyTime: "{{count}} rows have an empty \"{{field}}\" and cannot be placed on the time axis; they were excluded.",
        seriesFolded: "Series exceed the {{cap}}-color limit; the remaining {{folded}} were folded into \"{{other}}\". The palette does not generate new colors for extra series — generated colors are indistinguishable from existing ones in color-blind mode.",
        tooManyCategories: "A {{chart}} is only readable with up to {{cap}} segments; there are {{count}} now. Lower \"Top N only\" or switch to a bar chart / table.",
        nonAdditiveFold: "\"{{agg}}\" values cannot simply be added; the \"{{other}}\" cell is the sum of each group's own result and is for reference only. For exact numbers use \"{{sum}}\" or \"{{count}}\".",
      },
    },
    table: {
      item: "Item",
      series: "Series",
      category: "Category",
      total: "Total",
    },
    chart: {
      noData: "No data for this combination. Try a different X-axis field or a wider date range.",
    },
    errors: {
      forbidden: "No read permission for \"{{resource}}\". Check this account's role in the company. (Original message: {{message}})",
      pickDatasetFirst: "First pick a dataset in \"① Select data\" on the left, then drag a chart onto the canvas.",
      unsupportedChart: "\"{{dataset}}\" cannot be drawn as a {{chart}} (missing required field types).",
    },
    export: {
      noWidgets: "There are no charts on the canvas to export.",
      unsupported: "This browser does not support image export.",
      failed: "Failed to export image.",
    },
    toolbox: {
      title: "Toolbox",
      collapse: "Collapse toolbox",
      exportTooltip: "Export canvas (PNG)",
      export: "Export canvas",
      clearCanvas: "Clear canvas",
      clearConfirm: "All {{count}} charts on the canvas will be removed, along with the save in this browser.",
      clearOk: "Clear",
      clearCancel: "Cancel",
      reload: "Reload data (clears the cache and refetches every dataset on the canvas)",
      reset: "Start over (clear canvas)",
      steps: {
        data: "Select data",
        dataValue: "New chart: {{name}}",
        chart: "Charts",
        chartValue: "{{count}} on canvas",
        axis: "Adjust X / Y axes of this chart",
      },
    },
    dataPanel: {
      hintBefore: "The ",
      hintStrong: "new charts",
      hintAfter: " you drag onto the canvas next will use this dataset. Charts already on the canvas are not replaced — one canvas can hold charts from different datasets (e.g. one for projects, one for receivables).",
      search: "Search datasets or fields",
      noAccess: "This account has no readable data in the current company. Please check role permissions.",
      noMatch: "No matching datasets",
    },
    chartPanel: {
      pickDatasetFirst: "Pick a dataset in the previous step first.",
      hint: "{{count}} chart types available for \"{{dataset}}\" — drag one onto the canvas on the right, or click to add it:",
      dragTitle: "Drag to the canvas, or click to add: {{chart}}",
      noDualAxis: "No dual-axis charts: aligning two axes is arbitrary and creates correlations that are not in the data. To compare two measures, use a scatter plot.",
    },
    inspector: {
      empty: "Click a chart on the canvas to edit its X / Y axes here.",
      dataset: "Data for this chart",
      chartType: "Chart type",
      filter: "Filters (period, dimensions)",
    },
    axis: {
      empty: "Click a chart on the canvas to set its X / Y axes here.",
      highCardinality: "{{field}} (many values)",
      suggested: "Suited to this chart",
      otherFields: "Other fields",
      noMeasure: "No measure",
      countOption: "Count (rows per segment)",
      measures: "Measures (sum, average)",
      othersDistinct: "Other fields (distinct count)",
      x: "X axis",
      xMeasure: "X axis (measure)",
      xPlaceholder: "Select X-axis field",
      y: "Y axis",
      yMeasure: "Y axis (measure)",
      yPlaceholder: "Select Y-axis field",
      grain: {
        day: "Day",
        week: "Week",
        month: "Month",
        quarter: "Quarter",
        year: "Year",
      },
      notSuggestedTime: "\"{{field}}\" is not a suggested X axis for a {{chart}}; segments will follow the time unit above.",
      notSuggestedDim: "\"{{field}}\" is not a suggested X axis for a {{chart}}; there may be many segments — narrow them with \"Top N only\" below.",
      aggregation: "Aggregation",
      distinctOnly: "\"{{field}}\" is not a measure, so sum or average is meaningless; only {{agg}} (number of different values per segment) is available.",
      seriesRequired: "Group by (required)",
      seriesOptional: "Group by (optional)",
      noSeries: "No grouping",
      seriesPlaceholder: "Select grouping field",
      seriesHint: "Grouping must use a dimension field, not a second measure.",
      scatterHint: "Scatter plots allow at most 3 series: any two colors may sit next to each other, so extras are folded into a gray \"Other\".",
      more: "More settings (sort, top N)",
      sort: "Sort",
      sortBy: {
        valueDesc: "Value: high → low",
        valueAsc: "Value: low → high",
        x: "By X-axis name",
      },
      topNAll: "Top N only (all)",
      topN: "Top N only ({{n}})",
      topNHint: "The rest are folded into \"Other\"; no new colors are generated.",
    },
    filter: {
      period: "Period",
      quick: {
        all: "All time",
        m1: "This month",
        m3: "Last 3 months",
        m12: "Last 12 months",
        y: "This year",
        custom: "Custom…",
      },
      byField: "By {{field}}",
      noDateField: "This dataset has no date field, so it cannot be filtered by time.",
      onlyValues: "Only these values",
      clear: "Clear",
    },
    widget: {
      noDataset: "This chart has no dataset yet",
      fetchFailed: "Failed to load data",
      rows: "{{n}} rows",
      noDatasetPicked: "No data selected",
      viewTable: "View table",
      viewChart: "View chart",
      duplicate: "Duplicate this chart",
      remove: "Remove from canvas",
      resize: "Resize",
    },
    canvas: {
      emptyTitle: "The canvas is empty",
      emptyHint: "Pick a dataset in \"① Select data\" on the left, then <strong>drag a chart here</strong> from \"② Charts\" (or click it).",
      emptyMulti: "A canvas can hold many charts: drag the title bar to move, drag the bottom-right corner to resize, and click a chart to adjust its X / Y axes on the left.",
      emptyMixed: "Charts from different datasets can share one canvas — go back to step ①, pick another dataset, and drag in another chart.",
    },
    page: {
      restored: "Restored your last canvas ({{count}} charts)",
      synced: "Synced canvas from the cloud ({{count}} charts)",
      exportFileName: "canvas-{{date}}.png",
      exported: "Canvas exported as PNG",
      exportFailed: "Export failed",
      expandToolbox: "Expand toolbox",
    },
  },
};
